import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
} from "@mui/lab";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "../../configApi/axiosConfig";
import { APIURL } from "../../configApi/apiConfig";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import StoreIcon from "@mui/icons-material/Store";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import { ModalFirmaElectronica } from "./ModalFirmaElectronica";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PhoneIcon from "@mui/icons-material/Phone";
import { useNavigate } from "react-router-dom";
import useBodegaUsuario from "../../hooks/useBodegaUsuario";

import { enqueueSnackbar } from "notistack";
import { useAuth } from "../AuthContext/AuthContext";
import PhoneDisabledIcon from "@mui/icons-material/PhoneDisabled";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import LocationModal from "./LocationModal";
import VerificacionTerrenaModal from "./VerificacionTerrenaModal";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty"; // PENDIENTE
import HomeIcon from "@mui/icons-material/Home"; // DATOS DOMICILIO
import ContactsIcon from "@mui/icons-material/Contacts"; // DATOS REFERENCIAS
import CreditScoreIcon from "@mui/icons-material/CreditScore"; // INFORMACIÓN DE CRÉDITO
import AssessmentIcon from "@mui/icons-material/Assessment"; // FACTORES DE CRÉDITO
import { Box, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert"; // Icono de tres puntos verticales
import DocumentStatusPopover from "./DocumentStatusPopover";
import DomicilioModal from "./DomicilioModal";
import TrabajoModal from "./TrabajoModal";
import { RegistroCivil } from "./RegistroCivil/RegistroCivil";
import uploadFile from "../../hooks/uploadFile";
import { Loader } from "../Utils/Loader/Loader";
import EditIcon from "@mui/icons-material/Edit";
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import BlockIcon from '@mui/icons-material/Block';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import PreDocumentos from "./Pre-Documentos";
import { useRef } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import { fetchConsultaYNotifica, fechaHoraEcuador } from "../Utils";
import { CambioBodega } from "./CambioBodega";
import CapturarCamara from "../CapturarCamara/CapturarCamara";
import ModalConfirmacionRechazo from "../SolicitudGrande/Cabecera/ModalConfirmacionRechazo";
import ModalCorreccion from "../SolicitudGrande/Cabecera/ModalCorreccion";
import ListVerifDomicilioModal from "./ListVerifDomicilioModal";
import ListVerifLaboralModal from "./ListVerifLaboralModal"
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import { DocumentoDescarga } from './DocumentoDescarga';
import { MotivoContinuidad } from './MotivoContinuidad';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { ConfirmarAccionModal } from "./ConfirmarAccionModal";
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { PiMicrosoftExcelLogoBold } from "react-icons/pi";
import EditNoteIcon from '@mui/icons-material/EditNote';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import CallEndIcon from '@mui/icons-material/CallEnd';
import WorkIcon from '@mui/icons-material/Work';
import SearchIcon from '@mui/icons-material/Search';
import ExcelModal from './ExcelModal'
import { BsFillSignStopFill } from "react-icons/bs";
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { FaTruckFast } from "react-icons/fa6";
import { FaBoxArchive } from "react-icons/fa6";
import { Pencil } from "lucide-react";
import { ObservacionCredito } from "./ObservacionCredito/ObservacionCredito";
import VerificacionFacialModal from "./VerificacionFacialModal";
import VerificacionFacialLoadingModal from "./VerificacionFacialLoadingModal";
import { VerDetallesModal } from "./VerDetallesModal";
import { FaFileSignature, FaCheckCircle, FaFileAlt } from "react-icons/fa";
import { LuScanFace } from "react-icons/lu";
import { MdOutlineLinkOff, MdOutlineLink } from "react-icons/md";
import { AiOutlineClockCircle, AiOutlineCloseCircle, AiOutlineCheckCircle } from "react-icons/ai";
import { SiLinkfire } from "react-icons/si";
import { BsPersonBoundingBox } from "react-icons/bs";
import { BsPersonBadge, BsPersonBadgeFill    } from "react-icons/bs";
import { PiTimerLight, PiFileLight, PiEnvelopeLight, PiUserCircleLight, PiXLight, PiWarningLight, PiSignatureLight, PiNewspaperBold, PiSignatureFill, PiSealQuestionFill  } from "react-icons/pi";
import { TbSignatureOff } from "react-icons/tb";

export function ListadoSolicitud() {
  const {
    data,
    loading,
    error,
    fetchBodegaUsuario,
    listaVendedoresporBodega,
    vendedor,
    analista,
    listadoAnalista,
  } = useBodegaUsuario();

  const [recargar, setRecargar] = useState(false);
  const [loadingConsulta, setLoadingConsulta] = useState(false);

  // Caché para consultas que no cambian frecuentemente
  const [cacheTipoConsulta, setCacheTipoConsulta] = useState(null);
  const [cacheTipoCliente, setCacheTipoCliente] = useState(null);
  const [cacheAnalistas, setCacheAnalistas] = useState(null);
  const [cacheOperadores, setCacheOperadores] = useState(null);


  // Inicialización segura para evitar valores fuera de rango en el Select
  const getInitialBodega = () => {
    const saved = sessionStorage.getItem('filtroBodega');
    if (!saved || saved === 'todos') return 'todos';
    // Si el valor guardado no está en las opciones, usar 'todos'
    return 'todos';
  };
  const [selectedBodega, setSelectedBodega] = useState(getInitialBodega());
  const [selectedVendedor, setSelectedVendedor] = useState(sessionStorage.getItem('filtroVendedor') || "todos");
  const [analistaSelected, setAnalistaSelected] = useState(sessionStorage.getItem('filtroAnalista') || "todos");
  const [operadorSelected, setOperadorSelected] = useState(sessionStorage.getItem('filtroOperador') || "todos");
  const [dataBodega, setDataBodega] = useState([]);
  const [estado, setEstado] = useState(sessionStorage.getItem('filtroEstado') || "todos");
  const [datos, setDatos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [view, setView] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [totalPages, setTotalPages] = useState(1); // Total de páginas
  const [total, setTotal] = useState(0); // Total de registros
  const [itemsPerPage, setItemsPerPage] = useState(5)
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [openVerificacionModal, setOpenVerificacionModal] = useState(false);
  const [openModalPendiente, setOpenModalPendiente] = useState(false);
  const today = new Date().toISOString().split("T")[0]; // Obtener la fecha de hoy en formato YYYY-MM-DD
  const [tipo, setTipo] = useState([]);
  const [tipoClienteMap, setTipoClienteMap] = useState({});
  const [tipoVerificacionSeleccionada, setTipoVerificacionSeleccionada] = useState(null);
  const [tipoVerificacionSeleccionada2, setTipoVerificacionSeleccionada2] = useState(null);
  const [tipoConsulta, setTipoConsulta] = useState([]);
  const date15DaysAgo = new Date();
  date15DaysAgo.setDate(date15DaysAgo.getDate() - 2);
  const date15DaysAgoStr = date15DaysAgo.toISOString().split("T")[0];
  const [fechaInicio, setFechaInicio] = useState(sessionStorage.getItem('filtroIniFecha') || date15DaysAgoStr);
  const [fechaFin, setFechaFin] = useState(sessionStorage.getItem('filtroFinFecha') || today);
  const [isDomicilioModalOpen, setDomicilioModalOpen] = useState(false);
  const handleCloseDomicilioModal = () => setDomicilioModalOpen(false);
  const [openRegistroCivil, setOpenRegistroCivil] = useState(false);
  const [isTrabajoModalOpen, setTrabajoModalOpen] = useState(false);
  const handleCloseTrabajoModal = () => setTrabajoModalOpen(false);
  const [domicilioData, setDomicilioData] = useState([]);
  const [trabajoData, setTrabajoData] = useState([]);
  const [idsTerrenas, setIdsTerrenas] = useState([]);
  const navigate = useNavigate();
  const { userData, idMenu, socket } = useAuth();
  const editarCodDac = userData?.idGrupo === 1 || userData?.idGrupo === 16 || userData?.idGrupo === 18;
  const editarCodDac2 = selectedRow?.Estado === 1;
  const [cedula, setCedula] = useState(sessionStorage.getItem('filtroCedula') || "");
  const [dactilar, setDactilar] = useState("");
  const [fileToUpload, setFileToUpload] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [urlCloudstorage, setUrlCloudstorage] = useState(null);
  const [resultadoVerificacion, setResultadoVerificacion] = useState([]);
  const [loadingVerificacion, setLoadingVerificacion] = useState(false);
  const [openCameraModal, setOpenCameraModal] = useState(false);
  const [imagenCapturada, setImagenCapturada] = useState(null);
  const [fechaTiempos, setfechaTiempos] = useState([]);
  const inputFileRef = useRef(null);
  const [showModalRechazo, setShowModalRechazo] = useState(false);
  const [listVerifDomiciModal, setListVerifDomiModal] = useState(false);
  const handleCloseVerifDomModal = () => setListVerifDomiModal(false);
  const [listVerifLaborModal, setListVerifLaborModal] = useState(false);
  const handleCloseVerifLabModal = () => setListVerifLaborModal(false);
  const [isOpenPDf, setIsOpenPdf] = useState(false);
  const [isOpenMotivo, setIsOpenMotivo] = useState(false);
  const [dataInforme, setDataInforme] = useState(null);
  const [openModalCodDag, setOpenModalCodDag] = useState(false);
  const [openConfirmModalCodDac, setOpenConfirmModalCodDac] = useState(false);
  const [codDact, setCodDact] = useState("");
  const [openModalExcel, setOpenModalExcel] = useState(false);
  const [openVerificacionModal2, setOpenVerificacionModal2] = useState(false);
  const [ExistPrefactura, setExistPrefactura] = useState(false);
  const [showModalCorrecion, setShowModalCorrecion] = useState(false);
  const [TipoVerificacion, setTipoVerificacion] = useState("");
  const [open, setOpen] = useState(false);
  const [observacionModalAbierto, setObservacionModalAbierto] = useState(false);
  const handleOpenEditModal = () => {
    setCodDact(selectedRow.CodigoDactilar);
    setOpenModalCodDag(true);
  };

  const handleUpdateClick = () => {
    if (codDact === null || codDact.length !== 10) {
      enqueueSnackbar("El código dactilar debe tener mínimo 10 dígitos.", { variant: "error" });
      return;
    }
    setOpenConfirmModalCodDac(true);
  };

  const handleConfirmUpdate = () => {
    fetchCodDact(selectedRow)

    // Cerrar modales
    setOpenConfirmModalCodDac(false);
    setOpenModalCodDag(false);
    setView(false);
  };

  const fetchCodDact = async (selectedRow) => {
    try {
      const url = APIURL.patch_codDactil(selectedRow.id);
      const response = await axios.patch(url, {
        CodDactilar: codDact,
      }, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      enqueueSnackbar("Código dactilar actualizado correctamente.", { variant: "success" })
      return response.data;
    } catch (error) {
      console.error("Error al actualizar el código dactilar", error);
      enqueueSnackbar("Error al actualizar el código dactilar.", { variant: "error" });
      return null;
    }
  };

  const fetchEstadoRegcivil = async () => {
    try {
      const url = APIURL.patch_EstadoRegcivil(selectedRow.id);
      const response = await axios.patch(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      enqueueSnackbar("Estado actualizado correctamente.", { variant: "success" })
      handleCloseDialog()
      return response.data;
    } catch (error) {
      console.error("Error al actualizar el Estado", error);
      enqueueSnackbar("Error al actualizar el Estado", { variant: "error" });
      return null;
    }
  }

  const fetchCuota = async (id) => {
    try {
      const url = APIURL.getSolicitudGrandeporId(id);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error al obtener solicitud grande", error);
    }
  }

  // Estado para modal de error visual
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorModalData, setErrorModalData] = useState({ tipo: '', mensaje: '', detalle: '' });

  // Estados para modal de verificación facial
  const [verificacionModalOpen, setVerificacionModalOpen] = useState(false);
  const [verificacionModalTipo, setVerificacionModalTipo] = useState('');
  const [verificacionModalData, setVerificacionModalData] = useState({});

  const fetchImagenRegistroCivil = async (cedula, dactilar) => {
    try {
      const token = localStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };

      // Validar que userData esté disponible
      const usuario = userData?.Nombre || 'Sistema';

      // Usar directamente el nuevo endpoint que maneja todo automáticamente
      const response = await axios.post(
        "dactilar/reconocimiento-facial",
        {
          cedula,
          dactilar,
          usuario
        },
        config
      );

      // Verificar si fue exitoso
      if (response.data.success && response.data.data) {
        return { success: true, foto: response.data.data.FOTO };
      } else {
        // No se encontró el ciudadano - mostrar modal visual
        const mensaje = response.data.message || "No se encontró el ciudadano en el Registro Civil";
        setErrorModalData({
          tipo: 'ciudadano_no_encontrado',
          mensaje: 'Ciudadano no encontrado',
          detalle: `Los datos ingresados no coinciden con el Registro Civil:\n\n• Cédula: ${cedula}\n• Código Dactilar: ${dactilar}\n\nPor favor verifique que los datos sean correctos.`
        });
        setErrorModalOpen(true);
        return { success: false, error: mensaje };
      }
    } catch (error) {
      console.error('Error en fetchImagenRegistroCivil:', error);

      // Determinar el tipo de error
      if (error.response?.status === 404) {
        setErrorModalData({
          tipo: 'datos_incorrectos',
          mensaje: 'Datos incorrectos',
          detalle: `La cédula o código dactilar ingresado no existe en el sistema:\n\n• Cédula: ${cedula}\n• Código Dactilar: ${dactilar}\n\nVerifique los datos e intente nuevamente.`
        });
      } else if (error.response?.status === 500) {
        setErrorModalData({
          tipo: 'error_servidor',
          mensaje: 'Error del servidor',
          detalle: 'El servidor del Registro Civil no está disponible temporalmente. Por favor intente más tarde.'
        });
      } else {
        setErrorModalData({
          tipo: 'error_conexion',
          mensaje: 'Error de conexión',
          detalle: 'No se pudo conectar con el Registro Civil. Verifique su conexión a internet e intente nuevamente.'
        });
      }

      setErrorModalOpen(true);
      return { success: false, error: error.message };
    }
  };
  const handleAbrirVerificacionManual = async () => {
    const cedula = selectedRow?.cedula;
    const dactilar = selectedRow?.CodigoDactilar;
    const imagenSubida = selectedRow?.imagen;

    if (!cedula || !dactilar || !imagenSubida) {
      setErrorModalData({
        tipo: 'datos_incompletos',
        mensaje: 'Datos incompletos',
        detalle: 'No se pueden verificar las fotos porque faltan datos en la solicitud:\n\n' +
          `• Cédula: ${cedula || 'NO DISPONIBLE'}\n` +
          `• Código Dactilar: ${dactilar || 'NO DISPONIBLE'}\n` +
          `• Imagen: ${imagenSubida ? 'Disponible' : 'NO DISPONIBLE'}\n\n` +
          'Por favor complete los datos faltantes antes de continuar.'
      });
      setErrorModalOpen(true);
      return;
    }

    try {
      setCedula(cedula);
      setDactilar(dactilar);

      const result = await fetchImagenRegistroCivil(cedula, dactilar);

      if (result.success && result.foto && result.foto.trim() !== "") {
        // Ya tienes todo, abre el componente para mostrar
        setOpenRegistroCivil(true);
      }
      // Si falla, el modal de error ya se mostró en fetchImagenRegistroCivil
    } catch (error) {
      console.error('Error en handleAbrirVerificacionManual:', error);
      setErrorModalData({
        tipo: 'error_inesperado',
        mensaje: 'Error inesperado',
        detalle: 'Ocurrió un error inesperado al cargar la verificación facial. Por favor intente nuevamente.'
      });
      setErrorModalOpen(true);
    }
  };

  const handleVerificarIdentidad = async (imagenSubida, fotoRegistroCivil) => {
    try {
      setLoadingVerificacion(true);

      if (!imagenSubida || !fotoRegistroCivil) {
        setErrorModalData({
          tipo: 'datos_incompletos',
          mensaje: 'Imágenes faltantes',
          detalle: 'No se puede realizar la verificación facial porque faltan las imágenes necesarias:\n\n' +
            `• Imagen subida: ${imagenSubida ? 'Disponible ✓' : 'NO DISPONIBLE ✗'}\n` +
            `• Foto Registro Civil: ${fotoRegistroCivil ? 'Disponible ✓' : 'NO DISPONIBLE ✗'}\n\n` +
            'Asegúrese de que ambas imágenes estén cargadas correctamente antes de continuar.'
        });
        setErrorModalOpen(true);
        setLoadingVerificacion(false);
        return;
      }

      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      const body = {
        image1_url: imagenSubida,
        image2_base64: fotoRegistroCivil,
      };

      const response = await axios.post(
        APIURL.postCompareFaces(),
        body,
        config
      );


      // Extraer datos de la respuesta, con valores por defecto seguros
      const verified = response.data?.verified || false;
      const distance = response.data?.distance || 0;
      // threshold puede venir como null o undefined, usar valor por defecto
      const threshold = response.data?.threshold || response.data?.details?.threshold || 0.3;

      // ✅ Guarda los datos de verificación
      setResultadoVerificacion(response.data);

      // Calcular porcentaje de similitud de forma segura
      const similarityPercent = threshold > 0
        ? Math.max(0, Math.min(100, (1 - distance / threshold) * 100))
        : Math.max(0, Math.min(100, (1 - distance) * 100));

      if (verified) {
        await patchSolicitud(selectedRow?.id, 2);
        fetchInsertarDatos(6, selectedRow?.id, 2)

        // Abrir modal de verificación exitosa con nuevo componente
        setVerificacionModalTipo('aprobado');
        setVerificacionModalData({
          distance,
          threshold,
          similarity: similarityPercent
        });
        setVerificacionModalOpen(true);

        setOpenRegistroCivil(false);
        setView(false);
      } else {
        // Abrir modal de verificación rechazada con nuevo componente
        setVerificacionModalTipo('rechazado');
        setVerificacionModalData({
          distance,
          threshold,
          similarity: similarityPercent
        });
        setVerificacionModalOpen(true);
        setOpenRegistroCivil(false); // Cerrar modal de RegistroCivil cuando no coincide
      }
    } catch (error) {
      console.error("Error en verificación facial:", error);
      setErrorModalData({
        tipo: 'error_verificacion',
        mensaje: 'Error en verificación',
        detalle: 'Ocurrió un error al intentar verificar las imágenes. Por favor intente nuevamente más tarde.'
      });
      setErrorModalOpen(true);
    } finally {
      setLoadingVerificacion(false);
    }
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split('.').pop().toLowerCase();
    if (extension !== "jpeg" && extension !== "jpg" && extension !== "png") {
      enqueueSnackbar("Solo archivos con extensión .jpeg son permitidos", { variant: "error" });
      e.target.value = null; // reset input
      setFileToUpload(null);
      setPreviewUrl(null);
      return;
    }

    setFileToUpload(file);
    const localUrl = URL.createObjectURL(file);
    setPreviewUrl(localUrl);
  };

  const fetchInsertarimagen = async (tipo, data, estado, imagen) => {


    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      await axios.post(url, {
        idCre_SolicitudWeb: data,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,
        Telefono: imagen

      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error.response?.data || error.message);

    }
  };

  const handleUploadClick = async () => {
    if (!fileToUpload) {
      alert("Primero selecciona una imagen");
      return;
    }

    try {
      const fileUploadResponse = await uploadFile(
        fileToUpload,
        selectedRow.almacen,
        selectedRow.cedula,
        selectedRow.NumeroSolicitud,
        "Foto"
      );

      if (fileUploadResponse) {
        const updatedUrl = fileUploadResponse.url;

        // 1. Actualizar local
        setSelectedRow((prevRow) => ({
          ...prevRow,
          imagen: updatedUrl,
        }));

        // 2. Actualizar en la tabla
        setDatos((prevDatos) =>
          prevDatos.map((item) =>
            item.id === selectedRow.id ? { ...item, imagen: updatedUrl } : item
          )
        );

        // 3. Actualizar en backend
        const updatedData = { Foto: updatedUrl };
        await fetchActualizaSolicitud(selectedRow.id, updatedData);
        fetchInsertarimagen(1, selectedRow.id, 14, updatedUrl)

        setUrlCloudstorage();
        setFileToUpload(null);

        enqueueSnackbar("Foto subida correctamente", {
          variant: "success",
        });


      }
    } catch (error) {
      alert(error.message);
    }
  };


  const fetchActualizaSolicitud = async (idSolicitud, data) => {
    try {
      const url = APIURL.putUpdatesolicitud(idSolicitud); // URL para actualizar la solicitud
      const response = await axios.put(url, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response.data; // Retornar datos actualizados si es necesario
    } catch (error) {
      console.error("Error al actualizar la solicitud:", error.message);
      throw error; // Re-lanzar error para manejarlo más tarde
    }
  };

  const bodegas = data || []; // Safely access the bodegas data
  const vendedores = vendedor || []; // Safely access the vendedores data
  const analistas = analista || []; // Safely access the analistas data

  const estadosOpciones = [
    { label: "Todos", value: "todos" },
    { label: "PRE-APROBADO", value: 1 },
    { label: "APROBADO", value: 2 },
    { label: "ANULADO", value: 3 },
    { label: "RECHAZADO", value: 4 },
    { label: "NO APLICA", value: 5 },
    { label: "FACTURADO", value: 6 },
    { label: "CADUCADO", value: 7 },
    { label: "NOTA DE CRÉDITO", value: 8 },
    { label: "NOTA DE CRÉDITO AUTOMATICA", value: 9 },
  ];
  const [clienteEstados, setClienteEstados] = useState([]);

  const verificacionSolicitud = (data) => {
    return data.idEstadoVerificacionSolicitud !== 12;
  };

  ///// METODO QUE VALIDE SI 3 TIPOS DE DOCUMENTO UNICAMENTE YA FUERON APROBADOS 
  const [docAprobados, setDocAprobados] = useState({}); // 

  // función para verificar documentos
  const laboralYDomicilioAprobados = async (id) => {
    try {
      const response = await axios.get(APIURL.getVerificacionTresDocumentos(id));
      return response.data.allThreeDocsApproved; // true o false
    } catch (error) {
      console.error("Error fetching data:", error);
      return false; // si hay error, consideramos como no aprobado
    }
  };

  // ahora en el useEffect
  useEffect(() => {
    const verificarTodosDocumentos = async () => {
      const resultados = {}; // objeto para guardar resultados por id

      for (const solicitud of datos) {
        const aprobado = await laboralYDomicilioAprobados(solicitud.id);
        resultados[solicitud.id] = aprobado;
      }

      setDocAprobados(resultados); // guarda todo junto
    };

    if (datos.length > 0) {
      verificarTodosDocumentos();
    }
  }, [datos]);

  const estaDeshabilitado = (data) => {
    return data.resultado === 0;
  };

  const [solicitud, setSolicitud] = useState(sessionStorage.getItem('filtroSolicitud') || "Todos");

  /// estado solicitudes
  const estadoMap = {
    1: "PENDIENTE",
    10: "REVISIÓN",
    11: "CORRECIÓN",
    12: "APROBADO",
    13: "RECHAZADO",
  };

  const [documental, setDocumental] = useState(sessionStorage.getItem('filtroDocumental') || "Todos");
  const estadoDocumentalMap = {
    1: "PROCESO",
    2: "REVISIÓN",
    3: "CORRECIÓN",
    4: "APROBACION",
  };

  const [telefonica, setTelefonica] = useState(sessionStorage.getItem('filtroTelefonica') || "Todos");
  const estadoTelefonicaMap = {
    1: "NO ASIGNADO",
    2: "ASIGNADO",
    3: "APROBADO",
    4: "RECHAZADO",
    7: "CORRECCION"
  };

  const [domicilio, setDomicilio] = useState(sessionStorage.getItem('filtroDomicilio') || "Todos");
  const [laboral, setLaboral] = useState(sessionStorage.getItem('filtroLaboral') || "Todos");
  const [nombre, setNombre] = useState(sessionStorage.getItem('filtroNombre') || "");
  const [numeroSolicitud, setNumeroSolicitud] = useState(sessionStorage.getItem('filtroNumSolicitud') || "");
  const DomicilioLaboralMap = {
    1: "ASIGNADO",
    2: "DATOS VERIFICADOR",
    3: "RECHAZA VERIFICADOR",
    4: "APROBADO ANALISTA",
    5: "RECHAZA ANALISTA",
  };

  const estadoDeshabilitadoDocumental = (data) => {
    // Obtener el estado correspondiente al ID
    const estado = estadoDocumentalMap[data.idEstadoVerificacionDocumental];

    if (!estado) return true; // Si el estado no está mapeado, deshabilitar por seguridad
    // Buscar el permiso correspondiente en la lista de permisos
    const permiso = permisos.find(
      (p) => p.Permisos === `EDITAR DOCUMENTAL ${estado}`
    );
    // Retornar true si no existe el permiso o si no está activo
    return !permiso || !permiso.Activo;
  };

  const [openDialog2, setOpenDialog2] = useState(false);
  const [currentAction, setCurrentAction] = useState(null); // Estado para saber qué acción se va a realizar
  const [currentData, setCurrentData] = useState([]);
  const [laboralChecked, setLaboralChecked] = useState(false);
  const [domicilioChecked, setDomicilioChecked] = useState(false);
  const [entrada, setEntrada] = useState("");



  const [justificacion, setJustificacion] = useState("");

  const handleConfirm = async () => {
    if (currentAction === "estado") {
      handleApproveEstado(currentData, justificacion);
      if (laboralChecked) await patchLaboral(currentData.id);
      if (true) await patchDomicilio(currentData.id);
      if (entrada.trim() !== "") await patchEntrada(currentData.id, entrada);
    } else if (currentAction === "resultado") {
      handleApproveResultado(currentData);
      if (laboralChecked) await patchLaboral(currentData.id);
      if (domicilioChecked) await patchDomicilio(currentData.id);
      if (entrada.trim() !== "") await patchEntrada(currentData.id, entrada);
    }

    setOpenDialog2(false);
    setLaboralChecked(false);
    setDomicilioChecked(false);
    setEntrada("");
    setJustificacion("");
    setRecargar(true)
  };

  const patchEntrada = async (idSolicitud, valor) => {
    try {
      const response = await axios.patch(
        APIURL.update_solicitud(idSolicitud),
        {
          Entrada: parseFloat(valor),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        enqueueSnackbar("Entrada registrada correctamente.", {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Error al actualizar la entrada:", error);
      enqueueSnackbar("Error al actualizar la entrada.", {
        variant: "error",
      });
    }
  };

  const patchDomicilio = async (idSolicitud) => {
    try {
      const response = await axios.patch(
        APIURL.update_solicitud(idSolicitud),
        {
          TerrenoDomicilio: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        enqueueSnackbar("Solicitud actualizada correctamente.", {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Error al actualizar la solicitud:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", {
        variant: "error",
      });
    }
  };

  const patchLaboral = async (idSolicitud) => {
    try {
      const response = await axios.patch(
        APIURL.update_solicitud(idSolicitud),
        {
          TerrenoLaboral: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        enqueueSnackbar("Solicitud actualizada correctamente.", {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Error al actualizar la solicitud:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", {
        variant: "error",
      });
    }
  };

  const fetchInsertarDatos = async (tipo, data, estado) => {
    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      await axios.post(url, {
        idCre_SolicitudWeb: data,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,


      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error);
    }
  };

  const fetchInsertarDatosAprobarEstado = async (tipo, data, estado, observacion) => {
    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      await axios.post(url, {
        idCre_SolicitudWeb: data,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,
        Telefono: observacion


      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error);
    }
  };




  const fetchInsertarDatosRechazo = async (tipo, data, estado, observacion) => {
    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      await axios.post(url, {
        idCre_SolicitudWeb: data,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,
        Telefono: observacion


      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error);
    }
  };
  const fetchInsertarDatos2 = async (tipo, data, estado) => {
    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      const analistaNombre = analistas.find((a) => a.idUsuario === data.idAnalista)?.Nombre || "No disponible";
      await axios.post(url, {
        idCre_SolicitudWeb: data.id,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,
        Telefono: analistaNombre

      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error);
    }
  };

  const fetchInsertarDatos3 = async (tipo, data, estado) => {
    try {
      const url = APIURL.post_createtiemposolicitudeswebDto();

      const operadorNombre = operadores.find((a) => a.idUsuario === data.Operador)?.Nombre || "Vacio";
      await axios.post(url, {
        idCre_SolicitudWeb: data.id,
        Tipo: tipo,
        idEstadoVerificacionDocumental: estado,
        Usuario: userData.Nombre,
        Telefono: operadorNombre

      });
    } catch (error) {
      console.error("Error al guardar los datos del cliente", error);
    }
  };



  const handleApproveEstado = async (data, justificacion) => {
    try {
      await patchSolicitudEstadoyResultado(data.id, { Estado: 1, Resultado: 1 });
      //await patchSolicitudEstadoyResultado(data.id, { Resultado: 1 });
      await fetchInsertarDatosAprobarEstado(6, data.id, 1, justificacion); // ✅ Usar la nueva función con observación
      setRecargar(true);
      setShowModalRechazo(false)
    } catch (error) {
      console.error("Error al pre-aprobar estado:", error);
    }


  };

  const handleApproveResultado = (data) => {
    patchSolicitudEstadoyResultado(data.id, { Resultado: 1 });
    patchSolicitudEstadoyResultado(data.id, { Estado: 1 });
    fetchInsertarDatos(7, data.id, 1);
    setRecargar(true);
  };

  const patchSolicitudEstadoyResultado = async (
    idSolicitud,
    camposActualizar
  ) => {
    try {
      const response = await axios.patch(
        APIURL.update_solicitud(idSolicitud),
        camposActualizar, // Esto puede ser { Estado: 2 } o { Resultado: 1 }
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        enqueueSnackbar("Solicitud actualizada correctamente.", {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Error al actualizar la solicitud:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", {
        variant: "error",
      });
    }
  };

  const permisoAprobarResultado = (data) => {
    const permiso = permisos.find((p) => p.Permisos === `EDITAR RESULTADO`);
    // Retornar true si no existe el permiso o si no está activo
    return !permiso || !permiso.Activo;
  };

  const permisoAprobarEstado = (data) => {
    const permiso = permisos.find((p) => p.Permisos === `EDITAR ESTADO`);
    // Retornar true si no existe el permiso o si no está activo
    return !permiso || !permiso.Activo;
  };

  const tienePermisoEditarAnalista = () => {
    const permiso = permisos.find((p) => p.Permisos === "EDITAR ANALISTA");
    return permiso && permiso.Activo;
  };

  const permisoEditarOperador = () => {
    const permiso = permisos.find((p) => p.Permisos === "EDITAR OPERADORA");
    return permiso && permiso.Activo;
    // }
    //return true
  };

  const permitirEquifax = () => {
    const permiso = permisos.find((p) => p.Permisos === "CONSULTA EQUIFAX");
    return permiso && permiso.Activo;
  };

  const imprimirInforme = () => {
    const permiso = permisos.find((p) => p.Permisos === "IMPRIMIR INFORME SOLICITUDES")
    return permiso && permiso.Activo
  }

  const permisoReasignarVerificador = () => {
    const permiso = permisos.find((p) => p.Permisos === "REASIGNAR VERIFICADOR");
    return permiso && permiso.Activo;
  }

  const permisoEditarVerificacionTerreno = () => {
    const permiso = permisos.find((p) => p.Permisos === "EDITAR VERIFICACION TERRENA");
    return permiso && permiso.Activo;
  }

  const permisoReasignarDomicilio = () => {

    const permiso = permisos.find((p) => p.Permisos === "DESABILITAR DOMICILIO");
    return permiso && permiso.Activo;
  }

  const permisoAgregarObservacionCredito = () => {
    const permiso = permisos.find((p) => p.Permisos === "AGREGAR OBSERVACION CREDITO");
    return permiso && permiso.Activo;
  }

  const permisoReasignarLaboral = () => {
    const permiso = permisos.find((p) => p.Permisos === "DESABILITAR LABORAL");
    return permiso && permiso.Activo;
  }

  const permisoCambiarBodega = () => {
    const permiso = permisos.find((p) => p.Permisos === "CAMBIAR BODEGA");
    return permiso && permiso.Activo;
  }

  const puedeCrearSolicitud = () => {
    const permiso = permisos.find((p) => p.Permisos === "INGRESAR SOLICITUDES NUEVAS");
    return permiso && permiso.Activo;
  }

  const puedeCrearSolicitudNueva = () => {
    const permiso = permisos.find((p) => p.Permisos === "INGRESAR SOLICITUDES NUEVAS V2");
    return permiso && permiso.Activo;
  }

  const estadoDeshabilitadoporPermisos = (data) => {
    // Obtener el estado correspondiente al ID
    const estado = estadoMap[data.idEstadoVerificacionSolicitud];

    if (!estado) return true; // Si el estado no está mapeado, deshabilitar por seguridad

    // Buscar el permiso correspondiente en la lista de permisos
    const permiso = permisos.find(
      (p) => p.Permisos === `EDITAR SOLICITUD ${estado}`
    );

    // Retornar true si no existe el permiso o si no está activo
    return !permiso || !permiso.Activo;
  };

  const estadoDeshabilitadotelefonica = (data) => {
    // Obtener el estado correspondiente al ID
    const estado = estadoTelefonicaMap[data.idEstadoVerificacionTelefonica];

    if (!estado) return true; // Si el estado no está mapeado, deshabilitar por seguridad
    // Buscar el permiso correspondiente en la lista de permisos
    const permiso = permisos.find(
      (p) => p.Permisos === `EDITAR TELEFONICA ${estado}`
    );

    // Retornar true si no existe el permiso o si no está activo
    return !permiso || !permiso.Activo;
  };






  const estadoColores = {
    1: "#d0160e", // Rojo para Revisión
    2: "#f5a623", // Amarillo para Corrección
    3: "#2d3689", // Azul para Aprobado
    4: "#32CD32", // Verde para Aprobado
  };

  // Abre el Popover cuando el InfoIcon es clickeado
  const handlePopoverOpen = (event, tipo, data) => {
    fetchtiemposolicitudesweb(data.id, tipo);
    setPopoverData({
      open: true,
      anchorEl: event.currentTarget,
      selectedRowId: data.id, // Guardar la ID de la fila seleccionada
    });
  };

  const [popoverData, setPopoverData] = React.useState({
    open: false,
    anchorEl: null,
    clienteEstados: [],
    selectedRowId: null, // ID para identificar qué fila tiene el popover abierto
  });

  const handlePopoverClose = () => {
    setPopoverData({ open: false, anchorEl: null, selectedRowId: null });
  };

  const [userSolicitudData, setUserSolicitudData] = useState([]);
  const [userSolicitudData2, setUserSolicitudData2] = useState([]);

  // Estado para mostrar el modal de firma electrónica
  const [modalFirmaOpen, setModalFirmaOpen] = useState(false);

  // Cargar datos iniciales
  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          fetchTipoConsulta(),
          fetchBodega(),
          fetchTipoCliente(),
          fecthAnalista(),
          fetchOperador()
        ]);
        if (userData?.idUsuario && idMenu) {
          await permissionscomponents(idMenu, userData.idUsuario);
        }
      } catch (error) {
        console.error("Error al cargar los datos iniciales:", error);
      }
    };
    ///permissionscomponents(idMenu, userData.idUsuario);
    fetchData();
  }, []);

  const [permisos, setPermisos] = useState([]);

  const permissionscomponents = async (idMenu, idUsuario) => {
    try {
      const url = APIURL.getacces(idMenu, idUsuario);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const data = response.data;
        setPermisos(data);
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching permissions components:", error);
    }
  };

  const fetchtiemposolicitudesweb = async (idCre_SolicitudWeb, estado) => {
    try {
      const url = APIURL.get_tiemposolicitudesweb(idCre_SolicitudWeb, estado);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        const data = response.data;
        setClienteEstados(data);
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching tiemposolicitudesweb data:", error);
    }
  };

  const fetchTiempSolicweb = async (tipo, idCre_SolicitudWeb, estado) => {
    try {
      const url = APIURL.get_TiempSolicWeb(tipo, idCre_SolicitudWeb, estado);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        return response.data;
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching tiemposolicitudesweb data:", error);
      return null;
    }
  };

  const validaPrefactura = async (Cedula, Bodega) => {
    try {
      const url = APIURL.validaPrefactura(Cedula, Bodega);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {

        setExistPrefactura(true);
      } else {

        setExistPrefactura(false);
      }
    } catch (error) {
      console.error("Error fetching tiemposolicitudesweb data:", error);
      return null;
    }
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  //función para calcular la diferencia de tiempo
  const calcularTiempoTranscurrido = (fechaInicial, fechaFinal) => {
    if (!fechaInicial || !fechaFinal) return "N/A";

    const inicio = new Date(fechaInicial);
    const fin = new Date(fechaFinal);

    // Si las fechas son inválidas
    if (isNaN(inicio.getTime()) || isNaN(fin.getTime())) return "N/A";

    const diferencia = fin - inicio;

    // Convertir milisegundos a días, horas, minutos
    const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
    const horas = Math.floor(
      (diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));

    if (dias > 0) {
      return `${dias}d ${horas}h ${minutos}min`;
    } else if (horas > 0) {
      return `${horas}h ${minutos}min`;
    } else {
      return `${minutos}min`;
    }
  };

  const convertirTiempoASegundos = (tiempoStr) => {
    if (tiempoStr === "N/A") return 0;

    let segundos = 0;

    // Extraer días
    const diasMatch = tiempoStr.match(/(\d+)d/);
    if (diasMatch) {
      segundos += parseInt(diasMatch[1]) * 86400; // 1 día = 86400 segundos
    }

    // Extraer horas
    const horasMatch = tiempoStr.match(/(\d+)h/);
    if (horasMatch) {
      segundos += parseInt(horasMatch[1]) * 3600; // 1 hora = 3600 segundos
    }

    // Extraer minutos
    const minutosMatch = tiempoStr.match(/(\d+)min/);
    if (minutosMatch) {
      segundos += parseInt(minutosMatch[1]) * 60; // 1 minuto = 60 segundos
    }

    return segundos;
  };

  const convertirSegundosATuFormato = (totalSegundos) => {
    if (totalSegundos === 0) return "0min";

    const dias = Math.floor(totalSegundos / 86400);
    const horas = Math.floor((totalSegundos % 86400) / 3600);
    const minutos = Math.floor((totalSegundos % 3600) / 60);

    let resultado = [];

    if (dias > 0) resultado.push(`${dias}d`);
    if (horas > 0) resultado.push(`${horas}h`);
    if (minutos > 0) resultado.push(`${minutos}min`);

    return resultado.join(" ") || "0min";
  };

  const sumarTodosLosTiempos = () => {
    // Obtener todos los elementos con la clase 'tiempo-transcurrido'
    const elementosTiempo = Array.from(document.querySelectorAll('.tiempo-transcurrido'));

    let totalSegundos = 0;
    let tiemposValidos = 0;

    elementosTiempo.forEach(elemento => {
      const tiempoTexto = elemento.textContent.trim();
      if (tiempoTexto && tiempoTexto !== "N/A") {
        totalSegundos += convertirTiempoASegundos(tiempoTexto);
        tiemposValidos++;
      }
    });

    if (tiemposValidos === 0) return "N/A";

    return convertirSegundosATuFormato(totalSegundos);
  };

  const [tiempoTotal, setTiempoTotal] = useState("N/A");

  useEffect(() => {
    // Usar ResizeObserver para actualizar el tiempo total cuando cambia el tamaño
    const observer = new ResizeObserver(() => {
      const timer = setTimeout(() => {
        setTiempoTotal(sumarTodosLosTiempos());
      }, 100);
      return () => clearTimeout(timer);
    });

    // Observar el contenedor principal
    const dialogElement = document.querySelector('.MuiDialog-paper');
    if (dialogElement) {
      observer.observe(dialogElement);
    }

    // También actualizar cuando cambian las fechas
    setTiempoTotal(sumarTodosLosTiempos());

    return () => {
      if (dialogElement) {
        observer.unobserve(dialogElement);
      }
      observer.disconnect();
    };
  }, [fechaTiempos]);

  const [idsTerrenasMap, setIdsTerrenasMap] = useState({});
  const [openPreDocumentos, setOpenPreDocumentos] = useState(false);
  const [preDocumentosData, setPreDocumentosData] = useState(null);
  const handleOpenModalVerificacion = async (data, tipo) => {
    try {
      let idtipo = 0;
      if (tipo === "domicilio") idtipo = 1;
      else if (tipo === "trabajo") idtipo = 2;

      const url = APIURL.getIdsTerrenas(data.id, idtipo);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status !== 200) {
        throw new Error("Error al obtener los IDs terrenas");
      }

      const idsTerrenas = response.data;

      setIdsTerrenasMap((prev) => ({
        ...prev,
        [data.id]: idsTerrenas,
      }));

      setIdsTerrenas(idsTerrenas);
      setUserSolicitudData2(data);
      setTipoVerificacionSeleccionada2(tipo)

      if (!idsTerrenas || idsTerrenas.length === 0) {
        // No hay datos, abrir PreDocumentos (nuevo componente)
        setPreDocumentosData({ data, tipo });
        if (userData?.idGrupo !== 22 && userData?.idGrupo !== 23 && userData?.idGrupo !== 19) {
          setOpenPreDocumentos(true);
        }
        return;
      }

      if (tipo === "domicilio") {
        if (idsTerrenas.idTerrenaGestionDomicilio > 0) {
          setDomicilioData({ ...idsTerrenas, idSolicitud: data.id, cliente: data });
          //setDomicilioModalOpen(true);
          setListVerifDomiModal(true);
        } else if (idsTerrenas.idTerrenaGestionDomicilio === 0) {
          await fetchtiemposolicitudesweb(data.id, 4);
          setOpenModalPendiente(true);
        }
        return;
      }

      if (tipo === "trabajo") {
        if (idsTerrenas.idTerrenaGestionTrabajo > 0) {
          setTrabajoData({ ...idsTerrenas, idSolicitud: data.id, cliente: data });
          //setTrabajoModalOpen(true);
          setListVerifLaborModal(true)
        } else if (idsTerrenas.idTerrenaGestionTrabajo === 0) {
          await fetchtiemposolicitudesweb(data.id, 5);
          setOpenModalPendiente(true);
        }
        return;
      }

    } catch (error) {
      console.error("Error fetching data for verificación terrena:", error);
    }
  };

  const [selectDeshabilitado, setSelectDeshabilitado] = useState(false);

  useEffect(() => {
    if (userData?.Nombre && analistas?.length > 0) {
      const analistaCoincidente = analistas.find((a) => {
        const nombreAnalista = a.Nombre?.toLowerCase().trim();
        const nombreUser = userData.Nombre?.toLowerCase().trim();
        return nombreAnalista === nombreUser;
      });

      if (analistaCoincidente) {
        setAnalistaSelected(analistaCoincidente.idUsuario);
        setSelectDeshabilitado(true);
      } else {
        setSelectDeshabilitado(false);
      }
    }
  }, [userData?.Nombre, analistas]);

  // Obtener bodegas
  const fetchBodega = async () => {
    try {
      const userId = userData?.idUsuario;
      const idTipoFactura = 43;
      const fecha = new Date().toISOString();
      const recibeConsignacion = true;

      await fetchBodegaUsuario(
        userId,
        idTipoFactura,
        fecha,
        recibeConsignacion
      );
    } catch (err) {
      console.error("Error al obtener datos de la bodega:", err);
    }
  };

  // si cambia la bodega llamae a fecthUsuariobodega

  useEffect(() => {
    if (!userData?.FechaIngreso) return
    const fechaIngreso = new Date(userData.FechaIngreso).toISOString().split('T')[0];
    const idGrupo = userData?.idGrupo

    if (selectedBodega !== "todos") {
      if (idGrupo == 23 && fechaIngreso >= fechaInicio) {
        fecthaUsuarioBodega(fechaIngreso, selectedBodega, 0);
        setFechaInicio(fechaIngreso)
      } else {
        fecthaUsuarioBodega(fechaInicio, selectedBodega, 0);
      }
    } else {
      fetchSolicitudes();
    }
  }, [selectedBodega, fechaInicio, userData]);


  const fecthaUsuarioBodega = async (fecha, bodega, nivel) => {
    try {
      await listaVendedoresporBodega(fecha, bodega, nivel);
    } catch (err) {
      console.error("Error al obtener datos de la bodega:", err);
    }
  };

  const fecthAnalista = async () => {
    try {
      await listadoAnalista();
    } catch (err) {
      console.error("Error al obtener datos de la bodega:", err);
    }
  };

  const getIconByEstadoDocumental = (estadoId) => {
    switch (estadoId) {
      case 1: // Estado "Aprobado"
        return <UploadFileIcon sx={{ color: "rgb(117, 117, 117)" }} />; // Estado por defecto
      case 2: // Estado "En revisión"
        return <FactCheckIcon sx={{ color: "rgb(30, 136, 229)" }} />;
      case 3: // Estado "Corrección"
        return <ReportProblemIcon sx={{ color: "rgb(251, 140, 0)" }} />;
      case 4: // Estado "Aprobado"
        return <CheckCircleIcon sx={{ color: "rgb(56, 142, 60)" }} />;
      case 5: // Estado "Rechazado"
        return <HighlightOffIcon sx={{ color: "#DC3545" }} />;
    }
  };

  const getPhoneIconByEstado = (estado) => {
    switch (estado) {
      case 1: // NO ASIGNADO
        return <PhoneDisabledIcon />;
      case 2: // ASIGNADO
        return <PersonSearchIcon sx={{ color: "rgb(10, 80, 106)" }} />;
      case 3: // Aprobado
        return <CheckCircleIcon sx={{ color: "rgb(56, 142, 60)" }} />;
      case 4: // rechazado
        return <CallEndIcon sx={{ color: "rgb(239, 83, 80)" }} />;
      case 5:
        return <PhoneInTalkIcon sx={{ color: "#DC3545" }} />;
      case 7: // correccion
        return <EditNoteIcon sx={{ color: "rgb(251, 140, 0)" }} />;
      default: // Estado no especificado
        return <PhoneIcon />;
    }
  };

  const getSolicitudIconByEstado = (estado) => {
    switch (estado) {
      case 1: // PENDIENTE
        return <SupervisorAccountIcon sx={{ color: "gray" }} />;
      case 2: // DATOS CLIENTE
        return <PersonIcon sx={{ color: "gray" }} />;
      case 3: // DATOS DOMICILIO
        return <HomeIcon sx={{ color: "gray" }} />;
      case 4: // DATOS CÓNYUGE
        return <SupervisorAccountIcon sx={{ color: "gray" }} />;
      case 5: // DATOS REFERENCIAS
        return <ContactsIcon sx={{ color: "gray" }} />;
      case 6: // DATOS NEGOCIO
        return <StoreIcon sx={{ color: "gray" }} />;
      case 7: // DATOS DEPENDIENTE
        return <BadgeIcon sx={{ color: "gray" }} />;
      case 8: // INFORMACIÓN DE CRÉDITO
        return <CreditScoreIcon sx={{ color: "gray" }} />;
      case 9: // FACTORES DE CRÉDITO
        return <AssessmentIcon sx={{ color: "gray" }} />;
      case 10: // verificaciomn
        return <CheckCircleIcon sx={{ color: "rgb(30, 136, 229)" }} />;
      case 11:
        return <EditNoteIcon sx={{ color: "rgb(251, 140, 0)" }} />; // Azul para CORRECCIÓN
      case 12:
        return <CheckCircleIcon sx={{ color: "rgb(56, 142, 60)" }} />;
      case 13:
        return <BlockIcon sx={{ color: "rgb(211, 47, 47)" }} />; // Rojo para RECHAZADO
      // Verde para COMPLETADO
      default: // Default icon si el estado es desconocido
        return <HourglassEmptyIcon sx={{ color: "gray" }} />; // Fallback icon
    }
  };

  /*  const tipoVerificacionMap = {
    1: "Dirección incorrecta",
    2: "Aprobado",
    3: "Malas referencias",
    4: "No vive ahí",
    5: "Datos falsos",
    6: "Zona Vetada",
    7: "No sustenta ingresos",
  };*/

  const getIconDomicilio = (estadoId) => {
    switch (estadoId) {
      case 0: // Sin verificar
        return <HomeIcon sx={{ color: "gray" }} />;

      case 1: // Dirección incorrecta
        return <TwoWheelerIcon sx={{ color: "rgb(30, 136, 229)" }} />;

      case 2: // Aprobado
        return <CheckCircleIcon sx={{ color: "#28A745" }} />;

      case 3: // Malas referencias
        return <ReportProblemIcon sx={{ color: "#DC3545" }} />;

      case 4: // No vive ahí
        return <NotListedLocationIcon sx={{ color: "#DC3545" }} />;

      case 5: // Datos falsos
        return <DoNotDisturbIcon sx={{ color: "#DC3545" }} />;

      case 6: // Zona vetada
        return <BlockIcon sx={{ color: "#6c757d" }} />;

      case 7: // No sustenta ingresos
        return <MoneyOffIcon sx={{ color: "#FFC107" }} />;

      default:
        return <HomeIcon sx={{ color: "gray" }} />;
    }
  };

  const getIconLaboral = (estadoId) => {
    switch (estadoId) {
      case 0: // Sin verificar
        return <WorkIcon sx={{ color: "gray" }} />;

      case 1: // Dirección incorrecta
        return <TwoWheelerIcon sx={{ color: "rgb(30, 136, 229)" }} />;

      case 2: // Aprobado
        return <CheckCircleIcon sx={{ color: "#28A745" }} />;

      case 3: // Malas referencias
        return <ReportProblemIcon sx={{ color: "#DC3545" }} />;

      case 4: // No vive ahí
        return <NotListedLocationIcon sx={{ color: "#DC3545" }} />;

      case 5: // Datos falsos
        return <DoNotDisturbIcon sx={{ color: "#DC3545" }} />;

      case 6: // Zona vetada
        return <BlockIcon sx={{ color: "#6c757d" }} />;

      case 7: // No sustenta ingresos
        return <MoneyOffIcon sx={{ color: "#FFC107" }} />;

      default:
        return <HomeIcon sx={{ color: "gray" }} />;
    }
  };

  const puedeAprobar = (data) => {
    if (!data) return false;

    const condicionesBase =
      data.idEstadoVerificacionDocumental === 4 &&
      data.idEstadoVerificacionSolicitud === 12 &&
      data.idEstadoVerificacionTelefonica === 3;

    /*const verificacionDomicilioOk =
      !data.Domicilio || data.idEstadoVerificacionDomicilio === 2;

    const verificacionLaboralOk =
      !data.Laboral || data.idEstadoVerificacionTerrena === 2;
*/
    return condicionesBase
  };

  const bodegasIds = bodegas.map((bodega) => bodega.b_Bodega); // Obtener los IDs de las bodegas
  // Obtener tipo de consulta con caché
  const fetchTipoConsulta = async () => {
    // Verificar si ya existe en caché
    if (cacheTipoConsulta) {
      setTipoConsulta(cacheTipoConsulta);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(APIURL.getTipoConsulta(), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const data = response.data.map((item) => ({
          id: item.idCompraEncuesta,
          descripcion: item.Descripcion,
        }));
        setTipoConsulta(data);
        setCacheTipoConsulta(data); // Guardar en caché
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching tipo de consulta:", error);
    }
  };

  const fetchTipoCliente = async () => {
    // Verificar si ya existe en caché
    if (cacheTipoCliente) {
      const tipoMap = cacheTipoCliente.reduce((acc, item) => {
        acc[item.idTipoCliente] = item.Nombre;
        return acc;
      }, {});
      setTipoClienteMap(tipoMap);
      setTipo(
        cacheTipoCliente.map((item) => ({
          value: item.idTipoCliente,
          label: item.Nombre,
        }))
      );
      return;
    }

    try {
      const response = await axios.get(APIURL.getTipoCliente());
      if (response.status === 200) {
        // Guardar en caché
        setCacheTipoCliente(response.data);

        // Crear un mapeo de idTipoCliente a Nombre
        const tipoMap = response.data.reduce((acc, item) => {
          acc[item.idTipoCliente] = item.Nombre;
          return acc;
        }, {});
        setTipoClienteMap(tipoMap);
        setTipo(
          response.data.map((item) => ({
            value: item.idTipoCliente,
            label: item.Nombre,
          }))
        );
      } else {
        throw new Error("Error en la respuesta del servidor");
      }
    } catch (error) {
      console.error("Error al obtener el tipo de cliente:", error);
      enqueueSnackbar("No se pudo cargar los tipos de clientes", {
        variant: "error",
      });
    }
  };

  useEffect(() => {
    if (!socket) return;

    const onChanged = (data) => {
      // Forzar re-fetch
      setRecargar(prev => !prev);
    };

    socket.on("solicitud-web-changed", onChanged);

    return () => {
      socket.off("solicitud-web-changed", onChanged);
    };
  }, [socket]);


  // Obtener solicitudes con filtros aplicados
  // Solo ejecutar fetchSolicitudes cuando cambien currentPage o recargar
  useEffect(() => {
    if (tipoConsulta.length > 0 && dataBodega.length > 0) {
      fetchSolicitudes().finally(() => {
        setLoadingConsulta(false);
      });
    }
  }, [
    currentPage,
    recargar,
    tipoConsulta,
    dataBodega
  ]);

  // Función para el botón de consultar
  const handleConsultar = () => {
    setLoadingConsulta(true);
    setCurrentPage(1); // Resetear a la primera página
    setRecargar(prev => !prev); // Forzar recarga
  };

  useEffect(() => {

    // Resetear página si cambian filtros
    setCurrentPage(1);
  }, [
    tipoConsulta,
    selectedBodega,
    estado,
    fechaInicio,
    fechaFin,
    selectedVendedor,
    analistaSelected,
    solicitud,
    documental,
    telefonica,
    domicilio,
    laboral,
    nombre,
    numeroSolicitud,
    cedula,
  ]);
  const [openDialog3, setOpenDialog3] = useState(false);
  const [analistasDisponibles, setAnalistasDisponibles] = useState([]);
  const [analistaSeleccionado, setAnalistaSeleccionado] = useState(null);
  const [filaActual, setFilaActual] = useState(null);
  const [openDialogConfirmar, setOpenDialogConfirmar] = useState(false); // Confirmación
  const [openDialogOperador, setOpenDialogOperador] = useState(false);
  const [operadorSeleccionado, setOperadorSeleccionado] = useState(null);
  const [openDialogConfirmarOperador, setOpenDialogConfirmarOperador] = useState(false); // Confirmación operador  // Nuevo: Confirmar asignación de operador y notificar

  const handleConfirmarAsignacion = async () => {
    try {
      setOpenDialogConfirmar(false);

      if (analistaSeleccionado === filaActual.idAnalista) {
        enqueueSnackbar("El analista seleccionado es el mismo que el actual.", {
          variant: "error",
        });
        setAnalistaSeleccionado(null)
        return;
      }

      await updateAnalista(filaActual, analistaSeleccionado);
      await fetchConsultaYNotifica(filaActual.id, filaActual, {
        title: "¡Nueva solicitud enviada a revisión! 👀",
        body: `Revisa la solicitud de crédito ${filaActual.numeroSolicitud} de 🧑‍💼 ${filaActual.PrimerNombre} ${filaActual.ApellidoPaterno} con CI. ${filaActual.cedula}
    Fecha: ${fechaHoraEcuador}`,
        type: "success",
        empresa: "CREDI",
        url: "", // Opcional
        tipo: "analista",
      });
      enqueueSnackbar("Analista actualizado correctamente", {
        variant: "success",
      });
      setAnalistaSeleccionado(null)
    } catch (error) {
      console.error("Error al confirmar la asignación:", error);
      enqueueSnackbar("Ocurrió un error al actualizar el analista.", {
        variant: "error",
      });
    }
  };


  const handleEditarAnalista = (fila) => {
    setFilaActual(fila);
    fetchAnalistas();
  };


  const handleEditarOperador = (fila) => {
    setFilaActual(fila);
    fetchOperador();
    setOpenDialogOperador(true);
  };

  // Confirmación de operador, igual que analista
  const handleConfirmarAsignacionOperador = async () => {
    try {
      setOpenDialogOperador(false);


      if (operadorSeleccionado === filaActual.idOperador) {
        enqueueSnackbar("El operador seleccionado es el mismo que el actual.", { variant: "info" });
        return;
      }

      await updateOperador(filaActual, operadorSeleccionado);
      await fetchConsultaYNotifica(filaActual.id, filaActual, {
        title: "¡Nueva solicitud asignada!",
        body: `Revisa la solicitud de crédito ${filaActual.NumeroSolicitud} de 🧑‍💼 ${filaActual.PrimerNombre} ${filaActual.ApellidoPaterno} - ${filaActual.cedula} de ${filaActual.almacen}  \nFecha: ${new Date().toLocaleString("es-EC")}`,
        type: "success",
        empresa: "CREDI",
        url: "",
        tipo: "operador",
      });
      enqueueSnackbar("Operador actualizado correctamente", {
        variant: "success",
      });
      setOperadorSeleccionado(null);
    } catch (error) {
      console.error("Error al confirmar la asignación de operador:", error);
      enqueueSnackbar("Ocurrió un error al actualizar el operador.", {
        variant: "error",
      });
    }
  };


  const fetchAnalistas = async () => {
    // Verificar si ya existe en caché
    if (cacheAnalistas) {
      const activos = cacheAnalistas.filter((a) => a.Estado === 1);
      setAnalistasDisponibles(activos);
      setOpenDialog3(true);
      return;
    }

    try {
      const response = await axios.get(APIURL.analistacredito(), {
        headers: { method: "GET", cache: "no-store" },
      });

      // Guardar en caché
      setCacheAnalistas(response.data);

      const activos = response.data.filter((a) => a.Estado === 1);
      setAnalistasDisponibles(activos);
      setOpenDialog3(true);
    } catch (error) {
      console.error("Error al obtener analistas:", error);
    }
  };

  const updateAnalista = async (fila, numero) => {

    try {

      const response = await axios.patch(
        APIURL.update_solicitud(fila.id),
        {
          idAnalista: numero,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    } catch (error) {
      console.error("Error al actualizar la solicitud:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", {
        variant: "error",
      });
    }

    fetchInsertarDatos2(8, fila, 1)
  };

  const updateOperador = async (fila, numero) => {

    try {
      const response = await axios.patch(
        APIURL.update_solicitud(fila.id),
        {
          idOperador: numero,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    } catch (error) {
      console.error("Error al actualizar la solicitud:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", {
        variant: "error",
      });
    }

    fetchInsertarDatos3(9, fila, 1)
  };

  const [operadores, setOperadores] = useState([]);

  const fetchOperador = async () => {
    // Verificar si ya existe en caché
    if (cacheOperadores) {
      setOperadores(cacheOperadores);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(APIURL.getUsuarioPorROL(16), {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        // Guardar en caché
        setCacheOperadores(response.data);
        setOperadores(response.data);
      }
    } catch (error) {
      console.error("Error al obtener operadores:", error);
    }
  };

  const fetchSolicitudes = async () => {
    // Primero se obtiene el array de bodegas
    let bodegasId = [];
    // Verificar que tipoConsulta y dataBodega no estén vacíos
    if (tipoConsulta.length === 0 || dataBodega.length === 0) return;

    try {
      const token = localStorage.getItem("token");
      const offset = (currentPage - 1) * itemsPerPage;

      // Si selectedBodega es "todos", pasar un array vacío (esto también se puede ajustar según el comportamiento deseado)
      if (selectedBodega !== "todos") {
        // Si selectedBodega tiene un valor específico, tomarlo como un array
        bodegasId = [selectedBodega];
      } else {
        // Si es "todos", se puede pasar un array vacío o la lógica que desees
        bodegasId = bodegasIds; // Aquí se asigna el array de bodegas
      }

      if (userData?.idGrupo === 23) {
        const vendedorFiltrado = vendedores.find(
          (v) => v?.Codigo?.trim() === userData?.Nombre?.trim()
        );

        if (!vendedorFiltrado) {
          // Si no hay vendedor valido no se hace la consulta 
          setDatos([]);
          setTotal(0);
          setTotalPages(1);
          return;
        }
      }


      const response = await axios.post(
        APIURL.getCreSolicitudCredito(), // URL del endpoint POST
        {
          limit: itemsPerPage,
          offset: offset,
          fechaInicio: fechaInicio,       // debe ser string en formato ISO
          fechaFin: fechaFin,             // debe ser string en formato ISO
          bodega: bodegasId,              // array de números
          estado: estado === "todos" ? 0 : estado,
          vendedor: selectedVendedor === "todos" ? 0 : selectedVendedor,
          analista: analistaSelected === "todos" ? 0 : analistaSelected,
          EstadoSolicitud: solicitud == "Todos" ? 0 : solicitud,
          EstadoDocumental: documental == "Todos" ? 0 : documental,
          EstadoTelefonica: telefonica == "Todos" ? 0 : telefonica,
          EstadoDomicilio: domicilio == "Todos" ? 0 : domicilio,
          EstadoLaboral: laboral == "Todos" ? 0 : laboral,
          nombres: nombre?.trim() || undefined,
          numeroSolicitud: numeroSolicitud?.trim() || undefined,
          cedula: cedula?.trim() || undefined,
          operador: operadorSelected === "todos" ? 0 : operadorSelected
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );


      if (response.status === 201) {
        const totalRecords = response.data.total;
        const totalPages = Math.ceil(totalRecords / itemsPerPage);

        // Mapeo de datos con fetchVendedor
        const datos = await Promise.all(
          response.data.data.map(async (item) => {
            const vendedorNombre = await fetchVendedor(item.idVendedor);
            return {
              id: item.idCre_SolicitudWeb,
              PDFTerrena: item.PDFTerrena,
              NumeroSolicitud: item.NumeroSolicitud,
              nombre: `${item.PrimerNombre} ${item.SegundoNombre} ${item.ApellidoPaterno} ${item.ApellidoMaterno}`,
              PrimerNombre: item.PrimerNombre,
              SegundoNombre: item.SegundoNombre,
              ApellidoPaterno: item.ApellidoPaterno,
              ApellidoMaterno: item.ApellidoMaterno,
              cedula: item.Cedula,
              bodega: item.Bodega,
              almacen:
                dataBodega.find((bodega) => bodega.value === item.Bodega)
                  ?.label || "Desconocido",
              vendedor: vendedorNombre,
              consulta:
                tipoConsulta.find((tipo) => tipo.id === item.idCompraEncuesta)
                  ?.descripcion || "CLIENTE NO APLICA",
              estado:
                item.Estado === 1
                  ? "PRE-APROBADO"
                  : item.Estado === 2
                    ? "APROBADO"
                    : item.Estado === 3
                      ? "ANULADO"
                      : item.Estado === 4
                        ? "RECHAZADO"
                        : item.Estado === 5
                          ? "NO APLICA"
                          : item.Estado === 6
                            ? "FACTURADO"
                            : item.Estado === 7
                              ? "CADUCADO"
                              : item.Estado === 8
                                ? "NOTA DE CRÉDITO"
                                : item.Estado === 9
                                  ? "NOTA DE CRÉDITO AUTOMÁTICA"
                                  : "Desconocido",
              imagen: item.Foto,
              Estado: item.Estado,
              celular: item.Celular,
              email: item.Email,
              fecha: item.Fecha,
              afiliado: item.bAfiliado ? "Sí" : "No",
              tieneRuc: item.bTieneRuc ? "Sí" : "No",
              tipoCliente: tipoClienteMap[item.idTipoCliente] || "NO APLICA",
              idEstadoVerificacionDocumental:
                item.idEstadoVerificacionDocumental,
              idEstadoVerificacionSolicitud: item.idEstadoVerificacionSolicitud,
              idEstadoVerificacionTelefonica:
                item.idEstadoVerificacionTelefonica,
              idEstadoVerificacionTerrena: item.idEstadoVerificacionTerrena,
              resultado: item.Resultado,
              entrada: item.Entrada,
              Domicilio: item.TerrenoDomicilio,
              Laboral: item.TerrenoLaboral,
              CodigoDactilar: item.CodDactilar,
              idEstadoVerificacionDomicilio: item.idEstadoVerificacionDomicilio,
              idAnalista: item.idAnalista,
              Operador: item.idOperador,
              idProducto: item.idProductos == 1
                ? "COMBOS"
                : item.idProductos == 2
                  ? "LAVADORA"
                  : item.idProductos == 3
                    ? "MOVILIDAD"
                    : item.idProductos == 4
                      ? "PORTATIL"
                      : item.idProductos == 5
                        ? "REFRIGERADOR"
                        : item.idProductos == 6
                          ? "TELEVISOR"
                          : item.idProductos == 8
                            ? "IPHONE"
                            : "DESCONOCIDO",
              idVendedor: item.idVendedor,
              idMotivoContinuidad: item.idMotivoContinuidad,
              FechaAfiliacionIngreso: item.FechaIngreso,
              FechaAfiliacionHasta: item.FechaAfiliacionHasta,
              idFirmaElectronica: item.idFirmaElectronica,
              idEstadoAnalisisDeIdentidad: item.idEstadoAnalisisDeIdentidad,
              sCre_SolicitudWeb: item.sCre_SolicitudWeb,


            };
          })
        );
        setDatos(datos);
        setTotal(totalRecords);
        setTotalPages(totalPages);
      } else {
        console.error(`Error: ${response.status} - ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Obtener vendedor
  const fetchVendedor = async (idVendedor) => {
    try {
      const response = await axios.get(APIURL.getVendedor(idVendedor), {
        headers: { method: "GET", cache: "no-store" },
      });

      if (response.status === 200) {
        const vendedor = response.data;
        return (
          `${vendedor.PrimerNombre || ""} ${vendedor.SegundoNombre || ""} ${vendedor.ApellidoPaterno || ""
            } ${vendedor.ApellidoMaterno || ""}`.trim() || "No disponible"
        );
      }
    } catch (error) {
      console.error("Error fetching vendedor data:", error);
      return "No disponible";
    }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      setDataBodega(
        data.map((item) => ({
          value: item.b_Bodega,
          label: item.b_Nombre,
        }))
      );
    }
  }, [data]);

  //// patch solicitud cuando se aprueba la solicitud de credito

  const patchSolicitud = async (idSolicitud, numero) => {
    try {
      const response = await axios.patch(
        APIURL.update_solicitud(idSolicitud),
        {
          Estado: numero,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data) {
        enqueueSnackbar("Solicitud actualizada correctamente.", {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Error al actualizar la solicitud:", error);
      enqueueSnackbar("Error al actualizar la solicitud.", {
        variant: "error",
      });
    }
  };




  const handledocumentos = (registro) => {
    const stateData = {
      id: registro.id,
      NumeroSolicitud: registro.NumeroSolicitud,
      nombre: registro.nombre,
      cedula: registro.cedula,
      fecha: registro.fecha,
      almacen: registro.almacen,
      foto: registro.imagen,
      vendedor: registro.vendedor,
      consulta: registro.consulta,
      idEstadoVerificacionDocumental: registro.idEstadoVerificacionDocumental,
      estadoVerifD: registro.idEstadoVerificacionDocumental,
	  idFirmaElectronica: registro.idFirmaElectronica
    };

    if (
      registro.idEstadoVerificacionDocumental === 2 ||
      registro.idEstadoVerificacionDocumental === 4
    ) {
      navigate("/gestorDocumentos", {
        replace: true,
        state: stateData,
      });
    } else {
      navigate("/documental", {
        replace: true,
        state: stateData,
      });
    }
  };

  const handleTelefonica = (registro) => {
    navigate("/telefonicaList", {
      replace: true,
      state: {
        id: registro.id,
        NumeroSolicitud: registro.NumeroSolicitud,
        nombre: registro.nombre,
        cedula: registro.cedula,
        fecha: registro.fecha,
        almacen: registro.almacen,
        foto: registro.imagen,
        vendedor: registro.vendedor,
        consulta: registro.consulta,
        idEstadoVerificacionTelefonica: registro.idEstadoVerificacionTelefonica,
        permisos: permisos,
        idVendedor: registro.idVendedor,
        idAnalista: registro.idAnalista
      },
    });
  };

  const handlesolicitud = (registro) => {
    navigate("/solicitudgrande", {
      replace: true,
      state: {
        data: registro,
      },
    });
  };

  const handleOpenFirmaElectronica = (registro) => {
    setSelectedRow(registro);
    setModalFirmaOpen(true);
  };



  const handleOpenDialog = async (row) => {

    const cuotaDato = await fetchCuota(row.id)

    setSelectedRow({
      ...row,
      CuotaAsignada: cuotaDato?.CuotaAsignada ?? null,
    });
    setView(true);
    const [tipo1, tipo2, tipo3, tipo4, tipo5] = await Promise.all([
      fetchTiempSolicweb(1, row.id, "10,12"),  //solicitudes
      fetchTiempSolicweb(2, row.id, "2,3"),    //telefonica 
      fetchTiempSolicweb(3, row.id, "2,4"),    //documental
      fetchTiempSolicweb(4, row.id, "1"),      //domicilio
      fetchTiempSolicweb(5, row.id, "1")       //laboral
    ]);

    await validaPrefactura(row.cedula, row.bodega);

    const resultados = {
      tipo1, tipo2, tipo3, tipo4, tipo5
    }
    setfechaTiempos(resultados);
  };

  const handleOpenDialogDomicilioLaboral = async (row, tipo) => {

    setSelectedRow(row);
    setTipoVerificacion(tipo);
    setShowModalCorrecion(true);
  };

  const handleOpenCambioBodega = async (row) => {
    setSelectedRow(row);
    setOpen(true);
  }

  const handleOpenObservacionCredito = async (row) => {
    setSelectedRow(row);
    setObservacionModalAbierto(true);
  };

  const handleCloseDialog = () => {
    setView(false);
    setSelectedRow(null);
    setPreviewUrl(null); // Limpiar imagen temporal
    setFileToUpload(null);
  };

  const handleSolictud = () => {
    navigate("/solicitud", { replace: true });
  };

  const handleNuevaSolicitud = () => {
    navigate("/nuevaSolicitud", { replace: true });
  }

  // Función para cambiar de página
  const changePage = (page) => {
    setCurrentPage(page);
  };

  const handleOpenModal = (data) => {
    setUserSolicitudData(data);

    setOpenLocationModal((prevState) => !prevState);
  };

  const handleCorreccion = async (observacion) => {
    const isDomicilio = TipoVerificacion === "domicilio";

    // Determinar los valores dinámicos
    const camposeleccionado = isDomicilio ? "Domicilio" : "Laboral";
    const campo = isDomicilio ? "TerrenoDomicilio" : "TerrenoLaboral";
    const idTipo = isDomicilio ? 4 : 5;
    const valorActual = selectedRow?.[camposeleccionado];
    // Convertir booleano a número (1 o 0)
    const nuevoValor = !valorActual ? 1 : 0;
    const idTipoVerificacion = nuevoValor ? 9 : 8; // 8 para corrección, 9 para aprobado

    // Actualizar estado (activar/desactivar)
    await patchSolicitudEstadoyResultado(selectedRow?.id, { [campo]: nuevoValor });

    // Insertar datos de rechazo
    await fetchInsertarDatosRechazo(idTipo, selectedRow?.id, idTipoVerificacion, observacion);

    handleCloseDialog();
    setShowModalCorrecion(false);
    setRecargar((prev) => !prev);
  };

  const handleConfirmarBodega = async ({ nota, bodegaSeleccionada }) => {
    // Lógica para manejar la confirmación de cambio de bodega


    await patchSolicitudEstadoyResultado(selectedRow?.id, { Bodega: bodegaSeleccionada });
    await fetchInsertarDatosRechazo(1, selectedRow?.id, 27, nota);

    setRecargar((prev) => !prev);
    setOpen(false);
  };

  const handleConfirmarObservacion = async (observacion) => {
    // await fetchInsertarDatosRechazo(7, selectedRow?.id, 29, observacion);
    // console.log("Observacion credito:", observacion.nota);

    await fetchInsertarDatosRechazo(10, selectedRow?.id, 1, observacion.nota);
    setShowModalRechazo(false);
    setRecargar((prev) => !prev);
  }

  const handleEquifax = () => {
    navigate("/equifaxx", {
      replace: true,
      state: {
        nombre: selectedRow.nombre,
        cedula: selectedRow.cedula,
        Fecha: selectedRow.fecha,
      },
    });
  }

  // filtros 
  const limpiarFiltros = () => {
    setFechaInicio(date15DaysAgoStr);
    setFechaFin(today);
    setAnalistaSelected("todos");
    setOperadorSelected("todos");
    setEstado("todos");
    setSolicitud("Todos");
    setDocumental("Todos");
    setTelefonica("Todos");
    setDomicilio("Todos");
    setLaboral("Todos");
    setCedula('')
    setNombre('')
    setNumeroSolicitud('')

    sessionStorage.removeItem('filtroIniFecha');
    sessionStorage.removeItem('filtroFinFecha');
    sessionStorage.removeItem('filtroAnalista');
    sessionStorage.removeItem('filtroOperador');
    sessionStorage.removeItem('filtroEstado');
    sessionStorage.removeItem('filtroSolicitud');
    sessionStorage.removeItem('filtroDocumental');
    sessionStorage.removeItem('filtroTelefonica');
    sessionStorage.removeItem('filtroDomicilio');
    sessionStorage.removeItem('filtroLaboral');
    sessionStorage.removeItem('filtroCedula')
    sessionStorage.removeItem('filtroNombre')
    sessionStorage.removeItem('filtroNumSolicitud')
    if (userData?.idGrupo !== 23) {
      setSelectedVendedor("todos");
      setSelectedBodega("todos");
      sessionStorage.removeItem('filtroVendedor');
      sessionStorage.removeItem('filtroBodega');
    }
  };


  useEffect(() => {
    if (userData?.idGrupo === 23) {
      if (bodegas.length > 0) {
        const primeraBodega = bodegas[0].b_Bodega;
        setSelectedBodega(primeraBodega);
        sessionStorage.setItem('filtroBodega', primeraBodega);
      }

      const vendedorAutorizado = vendedores.find(
        (v) => v.Codigo === userData.Nombre
      );
      if (vendedorAutorizado) {
        setSelectedVendedor(vendedorAutorizado.idPersonal);
        sessionStorage.setItem('filtroVendedor', vendedorAutorizado.idPersonal);
      }
    }
  }, [userData?.idGrupo, bodegas, vendedores]);

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const firmaElectronicaIcons = {
    0: { icon: <PiSignatureLight  size={25} color="#9ca3af" />, tooltip: "" },
    1: { icon: <PiSignatureLight  size={25} color="#2563eb" />, tooltip: "Firma electrónica disponible" },
    2: { icon: <SiLinkfire  size={30} color="#eab308" />, tooltip: "Link biométrico enviado" },
    3: { icon: <BsPersonBadge   size={30} color="#22c55e" />, tooltip: "Biométrico aprobado" },
    4: { icon: <BsPersonBadgeFill  size={30} color="#dc2626" />, tooltip: "Biométrico rechazado" },
    5: { icon: <PiTimerLight   size={30} color="#dc2626" />, tooltip: "Biométrico caducado" },
    6: { icon: <SiLinkfire  size={30} color="#2563eb" />, tooltip: "Envío de link de firma pendiente" },
    7: { icon: <PiNewspaperBold  size={30} color="#2563eb" />, tooltip: "Envío de URL de firma pendiente" },
    8: { icon: <PiSignatureFill   size={30} color="#2563eb" />, tooltip: "Cliente acepta firma pendiente" },
    9: { icon: <PiSignatureFill   size={30} color="#22c55e" />, tooltip: "Firma electrónica completada" },
    10: { icon: <TbSignatureOff  size={30} color="#dc2626" />, tooltip: "Cliente rechazó la firma" },
    11: { icon: <PiSealQuestionFill   size={30} color="#dc2626" />, tooltip: "Fallo en pregunta de seguridad" },
    12: { icon: <PiTimerLight  size={30} color="#dc2626" />, tooltip: "Link de firma vencido" },
  };

  useEffect(() => {
    fetchSolicitudes();
  }, [itemsPerPage, currentPage, recargar]);

  const handleRechazar = async (observacion) => {
    patchSolicitudEstadoyResultado(selectedRow?.id, { Estado: 4, Resultado: 0 });
    //patchSolicitudEstadoyResultado(selectedRow?.id, { Resultado: 0 });
    // fetchInsertarDatos(6, selectedRow?.id, 4);
    fetchInsertarDatosRechazo(6, selectedRow?.id, 4, observacion)
    handleCloseDialog()
    setShowModalRechazo(false); // <-- Cierra el modal de rechazo siempre que abras el de detalles

    setRecargar(prev => !prev);
  }

  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen overflow-auto">
      <div className="flex flex-col md:flex-row gap-4 md:gap-6 mb-4">
        <TextField
          label="Fecha Desde"
          type="date"
          variant="outlined"
          value={fechaInicio}
          onChange={(e) => { const fechaIniFiltro = e.target.value; setFechaInicio(fechaIniFiltro); sessionStorage.setItem('filtroIniFecha', fechaIniFiltro); }}
          fullWidth
          size="small"
          slotProps={{
            inputLabel: { shrink: true },
            input: {
              min: userData?.FechaIngreso
                ? new Date(userData.FechaIngreso).toISOString().split('T')[0]
                : undefined,
            },
          }}
        />
        <TextField
          label="Fecha Hasta"
          type="date"
          variant="outlined"
          value={fechaFin}
          onChange={(e) => { const fechaFinFiltro = e.target.value; setFechaFin(fechaFinFiltro); sessionStorage.setItem('filtroFinFecha', fechaFinFiltro); }}
          fullWidth
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <FormControl size="small" fullWidth>
          <InputLabel>Buscar por bodega</InputLabel>
          <Select
            value={selectedBodega}
            onChange={(e) => { const bodegaFiltro = e.target.value; setSelectedBodega(bodegaFiltro); sessionStorage.setItem('filtroBodega', bodegaFiltro); }}
            label="Buscar por nombre"
            disabled={userData?.idGrupo === 23}
          >
            <MenuItem value="todos">Todos</MenuItem>

            {bodegas.map((bodega) => (
              <MenuItem key={bodega.b_Bodega} value={bodega.b_Bodega}>
                {bodega.b_Nombre}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" fullWidth>
          <InputLabel>Buscar por Vendedor</InputLabel>

          <Select
            value={selectedVendedor}
            onChange={(e) => { const vendedorFiltro = e.target.value; setSelectedVendedor(vendedorFiltro); sessionStorage.setItem('filtroVendedor', vendedorFiltro); }}
            label="Buscar por nombre"
            disabled={userData?.idGrupo === 23}
          >
            {userData?.idGrupo !== 23 && (<MenuItem value="todos">Todos</MenuItem>)}
            {(userData?.idGrupo === 23 ? vendedores.filter(
              (vendedor) => vendedor?.Codigo === userData?.Nombre)
              : vendedores
            ).map((vendedor) => (
              <MenuItem key={vendedor.idPersonal} value={vendedor.idPersonal}>
                {`${vendedor.Nombre || ""}`.trim() || "No disponible"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel>Analista</InputLabel>
          <Select
            value={analistaSelected}
            onChange={(e) => { const analistaFiltro = e.target.value; setAnalistaSelected(analistaFiltro); sessionStorage.setItem('filtroAnalista', analistaFiltro); }}
            label="Analista"
          //disabled={selectDeshabilitado} //  solo si hubo match
          >
            <MenuItem value="todos">Todos</MenuItem>
            {analistas.map((vendedor) => (
              <MenuItem key={vendedor.idUsuario} value={vendedor.idUsuario}>
                {vendedor.Nombre?.trim() || "No disponible"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel>Operadores</InputLabel>
          <Select
            value={operadorSelected}
            onChange={(e) => { const operadorFiltro = e.target.value; setOperadorSelected(operadorFiltro); sessionStorage.setItem('filtroOperador', operadorFiltro); }}
            label="Operadores"
          >
            <MenuItem value="todos">Todos</MenuItem>
            {operadores.map((operador) => (
              <MenuItem key={operador.idUsuario} value={operador.idUsuario}>
                {operador.Nombre?.trim() || "No disponible"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel>Estado</InputLabel>
          <Select
            value={estado}
            onChange={(e) => { const estadoFiltro = e.target.value; setEstado(estadoFiltro); sessionStorage.setItem('filtroEstado', estadoFiltro); }}
            label="Estado"
          >
            {estadosOpciones.map((estado) => (
              <MenuItem key={estado.value} value={estado.value}>
                {estado.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="flex flex-col md:flex-row gap-4 md:gap-6 mb-4">
        <FormControl size="small" fullWidth>
          <InputLabel>Solicitud</InputLabel>
          <Select
            value={solicitud}
            onChange={(e) => { const solicitudFiltro = e.target.value; setSolicitud(solicitudFiltro); sessionStorage.setItem('filtroSolicitud', solicitudFiltro); }}
            label="Solicitud"
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {Object.entries(estadoMap).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" fullWidth>
          <InputLabel>Documental</InputLabel>
          <Select
            value={documental}
            onChange={(e) => { const documentalFiltro = e.target.value; setDocumental(documentalFiltro); sessionStorage.setItem('filtroDocumental', documentalFiltro); }}
            label="Documental"
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {Object.entries(estadoDocumentalMap).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel>Telefonica</InputLabel>
          <Select
            value={telefonica}
            onChange={(e) => { const telefonicaFiltro = e.target.value; setTelefonica(telefonicaFiltro); sessionStorage.setItem('filtroTelefonica', telefonicaFiltro); }}
            label="Telefonica"
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {Object.entries(estadoTelefonicaMap).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel>Domicilio</InputLabel>
          <Select
            value={domicilio}
            onChange={(e) => { const domicilioFiltro = e.target.value; setDomicilio(domicilioFiltro); sessionStorage.setItem('filtroDomicilio', domicilioFiltro); }}
            label="Domicilio"
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {Object.entries(DomicilioLaboralMap).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel>Laboral</InputLabel>
          <Select
            value={laboral}
            onChange={(e) => { const LaboralFiltro = e.target.value; setLaboral(LaboralFiltro); sessionStorage.setItem('filtroLaboral', LaboralFiltro); }}
            label="Laboral"
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {Object.entries(DomicilioLaboralMap).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

      </div>

      <div className="flex flex-col md:flex-row gap-4 md:gap-6 mb-4">
        {/* Busqueda por cedula */}

        <TextField
          label="Buscar por cédula"
          variant="outlined"
          value={cedula}
          onChange={(e) => { const cedulaFiltro = e.target.value; setCedula(cedulaFiltro); sessionStorage.setItem('filtroCedula', cedulaFiltro); }}
          fullWidth
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            endAdornment: <IconButton></IconButton>,
          }}
        />

        {/* Busqueda por nombre cliente  */}

        <TextField
          label="Buscar por nombre cliente"
          variant="outlined"
          value={nombre}
          onChange={(e) => { const nombreFiltro = e.target.value; setNombre(nombreFiltro); sessionStorage.setItem('filtroNombre', nombreFiltro); }}
          fullWidth
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            endAdornment: <IconButton></IconButton>,
          }}
        />

        {/* Busqueda por numero de solicitud */}
        <TextField
          label="Buscar por número de solicitud"
          variant="outlined"
          value={numeroSolicitud}
          onChange={(e) => { const numSoliFiltro = e.target.value; setNumeroSolicitud(numSoliFiltro); sessionStorage.setItem('filtroNumSolicitud', numSoliFiltro); }}
          fullWidth
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            endAdornment: <IconButton></IconButton>,
          }}
        />
      </div>
      {/* Botones de acción */}
      <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 mb-4">
        <button
          className="group relative flex items-center justify-center gap-2.5 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none min-w-[140px]"
          onClick={handleConsultar}
          disabled={loadingConsulta}
        >
          {loadingConsulta ? (
            <>
              <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Consultando...</span>
            </>
          ) : (
            <>
              <SearchIcon className="text-xl group-hover:scale-110 transition-transform duration-300" />
              <span>Consultar</span>
            </>
          )}
        </button>

        <button
          className="group relative flex items-center gap-2.5 px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0"
          onClick={limpiarFiltros}
        >
          <DeleteIcon className="text-xl group-hover:rotate-12 transition-transform duration-300" />
          <span>Limpiar</span>
        </button>
        {(puedeCrearSolicitud()) && (
          <button
            title="Nueva Solicitud"
            className="group relative flex items-center gap-2.5 px-6 py-3 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0 overflow-hidden"
            onClick={handleSolictud}
          >
            {/* Efecto de brillo */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 group-hover:animate-shimmer"></div>
            {/* Texto */}
            <span className="relative z-10">Nueva Solicitud</span>
          </button>)}
        {(puedeCrearSolicitudNueva()) && (
          <button
            title="Nueva Solicitud "
            className="group relative flex items-center gap-2.5 px-6 py-3 bg-gradient-to-r from-fuchsia-600 to-fuchsia-700 hover:from-fuchsia-700 hover:to-fuchsia-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0 overflow-hidden"
            onClick={handleNuevaSolicitud}
          >
            {/* Efecto de brillo */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 group-hover:animate-shimmer"></div>
            {/* Texto */}
            <span className="relative z-10">Nueva Solicitud</span>
          </button>)}

        {imprimirInforme() && (
          <button
            className="group relative flex items-center gap-2.5 px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0"
            onClick={() => setOpenModalExcel(true)}
          >
            <PiMicrosoftExcelLogoBold size={22} className="group-hover:scale-110 transition-transform duration-300" />
            <span>Crear Informe</span>
          </button>
        )}

      </div>


      <div className="p-6 bg-gray-50 rounded-xl">
        <div className="bg-white shadow-lg rounded-xl overflow-hidden border border-gray-200">
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 750,
              width: "100%",
              boxShadow: "none",
              margin: "0.5rem auto",
            }}
          >
            <Table
              stickyHeader
              sx={{
                borderSpacing: "0 10px",
                borderCollapse: "separate",
                marginTop: "-10px", // Reduce el espacio después del encabezado
              }}
            >
              <TableHead>
                <TableRow
                  sx={{
                    background:
                      "linear-gradient(90deg, #f9fafb 0%, #e5e7eb 100%)",
                    "& th": {
                      color: "#1e293b",
                      fontSize: "0.875rem",
                      fontWeight: 600,
                      padding: "8px 8px", // Reducido del padding vertical de 12px a 8px
                      borderBottom: "1px solid #e2e8f0", // Reducido el grosor del borde inferior
                    },
                  }}
                >
                  <TableCell align="center"> <span style={{ color: '#ec4899' }}></span> </TableCell>
                  <TableCell align="center">N° Solicitud</TableCell>
                  <TableCell align="center">Cliente</TableCell>
                  <TableCell align="center">Cédula</TableCell>
                  <TableCell align="center">Fecha</TableCell>
                  <TableCell align="center">Almacén</TableCell>
                  <TableCell align="center">Vendedor</TableCell>
                  <TableCell align="center">Estado</TableCell>
                  <TableCell align="center">Entrega Producto</TableCell>
                  <TableCell align="center">Tipo de Cliente</TableCell>
                  <TableCell align="center">Resultado</TableCell>
                  {/* <TableCell align="center">Entradas</TableCell> */}
                  <TableCell align="center">Detalles</TableCell>
                  <TableCell align="center">Digital</TableCell>
                  <TableCell align="center">Solicitudes</TableCell>
                  <TableCell align="center">Documental</TableCell>
                  <TableCell align="center">Telefonica</TableCell>
                  <TableCell align="center">Domicilio</TableCell>
                  <TableCell align="center">Laborales</TableCell>
                  <TableCell align="center">Analista</TableCell>
                  <TableCell align="center">Operador</TableCell>
                  <TableCell align="center"></TableCell>

                </TableRow>
              </TableHead>

              <TableBody sx={{ marginTop: 0 }}>
                {datos.map((data, index) => {
                  const isError = (data.Estado === 4 || data.Estado === 5 || data.Estado === 7);
                  const bgColor = isError
                    ? "#fee2e2"
                    : index % 2 === 0
                      ? "#f9fafb"
                      : "#ffffff";
                  const textColor = isError ? "#991b1b" : "#1f2937";
                  return (
                    <TableRow
                      key={data.id}
                      sx={{
                        backgroundColor: bgColor,
                        transition: "all 0.25s ease-in-out",
                        "&:hover": {
                          backgroundColor: isError ? "#fecaca" : "#f1f5f9",
                          boxShadow: "0 8px 15px rgba(0,0,0,0.12)",
                          transform: "translateY(-4px)",
                        },
                        "&:active": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.08)",
                        },
                        // Definimos bordes para todas las celdas
                        "& td": {
                          border: "1px solid",
                          borderColor: isError ? "#fecaca" : "#e5e7eb",
                          padding: "14px 8px",
                          fontSize: "0.875rem",
                          color: textColor,
                          transition: "all 0.25s ease-in-out",
                        },
                        // Aplicar esquinas redondeadas a primera y última celda
                        "& td:first-of-type": {
                          borderRadius: "8px 0 0 8px",
                          borderRight: "none",
                        },
                        "& td:last-of-type": {
                          borderRadius: "0 8px 8px 0",
                          borderLeft: "none",
                        },
                        // Para celdas intermedias, eliminamos bordes laterales duplicados
                        "& td:not(:first-of-type):not(:last-of-type)": {
                          borderLeft: "none",
                          borderRight: "none",
                        },
                        boxShadow: "0 1px 3px rgba(0,0,0,0.03)",
                        cursor: "pointer",
                      }}
                    >
                      <TableCell align="center">
                        {(data.Estado === 1 || data.Estado === 2) ? (
                          <button
                            onClick={() => {
                              setIsOpenMotivo(true);
                              setDataInforme(data);
                            }}
                            className="bg-pink-100 text-pink-800 hover:bg-pink-200 hover:text-pink-900 transition-all duration-200 rounded-full p-2"
                          >
                            <NoteAltIcon className="text-pink-800" />
                          </button>
                        ) : (
                          ""
                        )}
                      </TableCell>


                      <TableCell align="center">
                        {data.NumeroSolicitud}
                      </TableCell>
                      <TableCell align="center">{data.nombre}</TableCell>
                      <TableCell align="center" className="relative">

                        <div className="flex flex-col items-center justify-start h-[60px]">
                          <span className="text-gray-800 font-normal mb-2">{data.cedula}</span>


                          <div className="flex items-center justify-end w-full space-x-1">
                            {permisoAgregarObservacionCredito() && (
                              <button
                                onClick={() => handleOpenObservacionCredito(data)}
                                title="Observación de Crédito"
                                className="flex items-center justify-center h-6 w-6 rounded-full 
                   bg-white shadow-sm hover:bg-blue-50 hover:shadow-md 
                   transition-all duration-200 border border-gray-200"
                              >
                                <Pencil className="text-[#050771] w-4 h-4" />
                              </button>
                            )}


                            <button
                              onClick={(event) => handlePopoverOpen(event, 10, data)}
                              title="Observaciones"
                              className="flex items-center justify-center h-6 w-6 rounded-full 
                   hover:bg-gray-100 transition-colors duration-200"
                            >
                              <MoreVertIcon className="text-gray-600 w-5 h-5" />
                            </button>
                          </div>
                        </div>

                        {/* Popover de estado */}
                        <DocumentStatusPopover
                          open={popoverData.open && popoverData.selectedRowId === data.id}
                          anchorEl={popoverData.anchorEl}
                          onClose={handlePopoverClose}
                          clienteEstados={clienteEstados}
                          estadoColores={estadoColores}
                        />
                      </TableCell>

                      <TableCell align="center">
                        {new Date(data.fecha).toLocaleString()}
                      </TableCell>
                      <TableCell align="center">
                        {data.Estado === 1 && data.almacen == "POINT WEB" && permisoCambiarBodega() ? (
                          <div className="flex items-center justify-center">
                            <span>
                              <div className="relative inline-block">
                                <SyncAltIcon
                                  onClick={() => handleOpenCambioBodega(data)}
                                  className="absolute -top-5 -right-3 text-blue-600 cursor-pointer hover:text-blue-800 transition-colors duration-200"
                                  fontSize="small"
                                />

                              </div>
                            </span>
                          </div>
                        ) : null}
                        {data.almacen}
                      </TableCell>

                      <TableCell align="center">{data.vendedor}</TableCell>


                      <TableCell align="center">
                        {(data.estado === "RECHAZADO" || data.estado === "NO APLICA") ? (
                          <Box
                            sx={{
                              position: "relative",
                              display: "inline-block",
                              ...(permisoAprobarEstado(data)
                                ? {}
                                : {
                                  "&:hover .approveOverlay": {
                                    transform: "translateY(0)",
                                    opacity: 1,
                                  },
                                }),
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                display: "inline-flex",
                                px: 1.5,
                                py: 0.5,
                                fontSize: "0.75rem",
                                fontWeight: 500,
                                borderRadius: "9999px",
                                backgroundColor: "#fee2e2",
                                color: "#991b1b",
                                transition: "all 0.3s ease",
                              }}
                            >
                              {data.estado}
                            </Box>
                            {!permisoAprobarEstado(data) && (
                              <Box
                                className="approveOverlay"
                                onClick={() => {
                                  setCurrentAction("estado");
                                  setCurrentData(data); // Guarda la fila actual
                                  setOpenDialog2(true); // Abrir el diálogo para confirmar
                                }}
                                sx={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  bgcolor: "#dbeafe",
                                  borderRadius: "9999px",
                                  cursor: "pointer",
                                  transform: "translateY(100%)",
                                  opacity: 0,
                                  transition:
                                    "transform 0.3s ease, opacity 0.3s ease",
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: "#1e40af",
                                    fontSize: "0.75rem",
                                    fontWeight: 600,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <CheckCircleIcon fontSize="small" />
                                  PRE-APROBAR?
                                </Typography>
                              </Box>
                            )}
                          </Box>
                        ) : (
                          <Box
                            component="span"
                            sx={{
                              display: "inline-flex",
                              px: 1.5,
                              py: 0.5,
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              borderRadius: "9999px",
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                              backgroundColor: (() => {
                                switch (data.estado) {
                                  case "APROBADO":
                                    return "#dcfce7"; // verde claro
                                  case "PRE-APROBADO":
                                    return "#dbeafe"; // azul claro
                                  case "ANULADO":
                                    return "#f3f4f6"; // gris claro
                                  case "FACTURADO":
                                    return "#166534"; // verde oscuro
                                  case "RECHAZADO":
                                    return "#fee2e2"; // rojo claro
                                  case "CORRECCIÓN":
                                    return "#fef9c3"; // amarillo claro
                                  case "PENDIENTE":
                                    return "#fef9c3";
                                  case "DATOS CLIENTE":
                                    return "#e0f2fe"; // azul muy claro
                                  case "NOTA DE CRÉDITO":
                                    return "#e76843"; // azul muy claro
                                  case "NOTA DE CRÉDITO AUTOMÁTICA":
                                    return "#FF8C00"; // Anaranjado oscuro
                                  default:
                                    return "#f3f4f6"; // gris por defecto
                                }
                              })(),
                              color: (() => {
                                switch (data.estado) {
                                  case "APROBADO":
                                    return "#166534"; // verde fuerte
                                  case "PRE-APROBADO":
                                    return "#1e40af"; // azul fuerte
                                  case "ANULADO":
                                    return "#374151"; // gris oscuro
                                  case "FACTURADO":
                                    return "#ffffff"; // blanco
                                  case "RECHAZADO":
                                    return "#b91c1c"; // rojo fuerte
                                  case "CORRECCIÓN":
                                    return "#854d0e"; // marrón oscuro
                                  case "PENDIENTE":
                                    return "#854d0e";
                                  case "DATOS CLIENTE":


                                    return "#1e3a8a"; // azul medio
                                  case "NOTA DE CRÉDITO":
                                    return "#ffffff"; // blanco
                                  case "NOTA DE CRÉDITO AUTOMÁTICA":
                                    return "#ffffff"; // blanco
                                  default:
                                    return "#4b5563"; // gris medio
                                }
                              })(),
                            }}
                          >
                            {data.estado}
                          </Box>

                        )}

                        <div style={{ height: 12 }} />

                        <span
                          className="flex justify-end items-center "
                        >
                          <MoreVertIcon
                            onClick={(event) =>
                              handlePopoverOpen(event, 6, data)
                            }
                            style={{ cursor: "pointer" }}
                            className="ml-2 text-gray-400 hover:text-indigo-600 transition-colors duration-200"
                          />
                        </span>

                      </TableCell>
                      <TableCell align="center">
                        <Box component="span" sx={{ display: "inline-flex", gap: 1, ml: 1, alignItems: "center" }}>
                          {data.estado === "FACTURADO"
                            ? (
                              <>
                                {// Caso 1: Ambos terrenos en 0
                                  (
                                    (data.Domicilio === false && data.Laboral === false) ||

                                    // Caso 2: Solo Domicilio activo y aprobado
                                    (data.Domicilio === true && data.Laboral === false && data.idEstadoVerificacionDomicilio === 2) ||

                                    // Caso 3: Solo Laboral activo y aprobado
                                    (data.Domicilio === false && data.Laboral === true && data.idEstadoVerificacionTerrena === 2) ||

                                    // Caso 4: Ambos activos y ambos aprobados
                                    (data.Domicilio === true && data.idEstadoVerificacionDomicilio === 2 &&
                                      data.Laboral === true && data.idEstadoVerificacionTerrena === 2)
                                  ) ? (
                                    <Tooltip title="Puede entregar el producto." arrow placement="top">
                                      <span>
                                        <FaTruckFast size={30} color="green" />
                                      </span>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title="No se puede entregar el producto sin verificación." arrow placement="top">
                                      <span>
                                        <BsFillSignStopFill size={40} color="red" />
                                      </span>
                                    </Tooltip>
                                  )}
                              </>
                            ) : (
                              <>
                                <Tooltip title="Pendiente" arrow placement="top">
                                  <span>
                                    <FaBoxArchive size={20} color="gray" />
                                  </span>
                                </Tooltip>
                              </>
                            )}

                        </Box>
                      </TableCell>
                      <TableCell align="center">{data.tipoCliente}</TableCell>

                      <TableCell align="center">
                        {data.resultado === 0 ? (
                          // Ícono ❌ cuando resultado === 0
                          <Box
                            sx={{
                              position: "relative",
                              width: 28,
                              height: 28,
                              display: "inline-block",
                            }}
                          >
                            <HighlightOffIcon
                              sx={{
                                color: "#DC3545",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: 28,
                                height: 28,
                              }}
                            />
                            {data.idMotivoContinuidad > 0 && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: -6,
                                  right: -6,
                                  backgroundColor: "#9c154d",
                                  borderRadius: "50%",
                                  fontSize: 12,
                                  width: 10,
                                  height: 10,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: "bold",
                                  zIndex: 1,
                                }}
                              />
                            )}
                          </Box>
                        ) : data.resultado === 1 ? (

                          <Box sx={{ position: "relative", display: "inline-block", width: 28, height: 28 }}>
                            <CheckCircleIcon sx={{ color: "#28A745", fontSize: 28 }} />
                            {data.idMotivoContinuidad > 0 && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: -6,
                                  right: -6,
                                  backgroundColor: "#9c154d",
                                  borderRadius: "50%",
                                  fontSize: 12,
                                  width: 10,
                                  height: 10,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: "bold",
                                  zIndex: 1,
                                }}
                              />

                            )}
                          </Box>
                        ) : null}

                        {/* Ícono de acciones */}
                        <span>
                          <MoreVertIcon
                            onClick={(event) => handlePopoverOpen(event, 7, data)}
                            style={{ cursor: "pointer" }}
                          />
                        </span>

                      </TableCell>

                      <TableCell align="center">
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                          <Tooltip title="Ver más" arrow placement="top">
                            <IconButton
                              onClick={() => handleOpenDialog(data)}
                              size="small"
                              sx={{
                                bgcolor: isError ? "#fee2e2" : "#f1f5f9",
                                "&:hover": {
                                  bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                                  transform: "scale(1.1)",
                                },
                                transition: "all 0.2s ease",
                              }}
                            >
                              <VisibilityIcon
                                fontSize="small"
                                sx={{ color: isError ? "#b91c1c" : "#475569" }}
                              />
                              {data.idMotivoContinuidad > 0 && (
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: -6,
                                    right: -6,
                                    backgroundColor: "#9c154d",
                                    borderRadius: "50%",
                                    fontSize: 12,
                                    width: 10,
                                    height: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontWeight: "bold",
                                    zIndex: 1,
                                  }}
                                />
                              )}
                            </IconButton>
                          </Tooltip>

                        </div>
                      </TableCell>
                      <TableCell align="center">
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 4 }}>
                          {firmaElectronicaIcons[data.idFirmaElectronica] && (
                            <Tooltip title={firmaElectronicaIcons[data.idFirmaElectronica].tooltip} arrow placement="top">
                              <IconButton
                                size="small"
                                onClick={
                                  data.idFirmaElectronica !== 0 &&
                                    data.idEstadoVerificacionDocumental === 4 &&
                                    data.idEstadoVerificacionSolicitud === 12 &&
                                    data.idEstadoVerificacionTelefonica === 3
                                    ? () => handleOpenFirmaElectronica(data)
                                    : undefined
                                }
                                sx={{
                                  bgcolor: isError ? "#fee2e2" : "#f1f5f9",
                                  "&:hover": {
                                    bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                                    transform: "scale(1.1)",
                                  },
                                  transition: "all 0.2s ease",
                                }}
                              >
                                {firmaElectronicaIcons[data.idFirmaElectronica].icon}
                              </IconButton>

                            </Tooltip>
                          )}

                          <MoreVertIcon
                            onClick={(event) =>
                              handlePopoverOpen(event, 11, data)
                            }
                            style={{ cursor: "pointer" }}
                          />

                        </div>

                      </TableCell>


                      <TableCell align="center">
                        <div>

                          <span>
                            <IconButton
                              onClick={() => handlesolicitud(data)}
                              disabled={
                                estaDeshabilitado(data) ||
                                estadoDeshabilitadoporPermisos(data)
                              }
                              size="small"
                              sx={{
                                opacity: estaDeshabilitado(data) ? 0.4 : 1,
                                bgcolor: isError ? "#fee2e2" : "#f1f5f9",
                                "&:hover": {
                                  bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                                  transform: "scale(1.1)",
                                },
                                transition: "all 0.2s ease",
                              }}
                            >
                              {getSolicitudIconByEstado(
                                data.idEstadoVerificacionSolicitud
                              )}
                            </IconButton>
                            <span>
                              <MoreVertIcon
                                onClick={(event) =>
                                  handlePopoverOpen(event, 1, data)
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          </span>

                        </div>
                      </TableCell>

                      {/* Documental */}
                      <TableCell align="center">
                        <div>
                          <span>
                            <IconButton
                              onClick={() => handledocumentos(data)}
                              disabled={
                                //// data.idEstadoVerificacionDocumental === 2 ||
                                estaDeshabilitado(data) ||
                                estadoDeshabilitadoDocumental(data) ||
                                verificacionSolicitud(data)
                              }
                              size="small"
                              sx={{
                                opacity: estaDeshabilitado(data) ? 0.4 : 1,
                                bgcolor: isError ? "#fee2e2" : "#f1f5f9",
                                "&:hover": {
                                  bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                                  transform: "scale(1.1)",
                                },
                                transition: "all 0.2s ease",
                              }}
                            >
                              {getIconByEstadoDocumental(
                                data.idEstadoVerificacionDocumental
                              )}
                            </IconButton>

                            {/* InfoIcon al lado del IconButton */}
                            <span
                              style={{
                                // pointerEvents: estaDeshabilitado(data)
                                //   ? "none"
                                //   : "auto",
                                // opacity: estaDeshabilitado(data) ? 0.5 : 1,
                              }}
                            >
                              <MoreVertIcon
                                onClick={(event) =>
                                  handlePopoverOpen(event, 3, data)
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          </span>

                        </div>
                      </TableCell>

                      {/* Telefónica */}
                      <TableCell align="center">
                        <div>
                          <span>
                            <IconButton
                              onClick={() => handleTelefonica(data)}
                              disabled={
                                data.idEstadoVerificacionTelefonica === 1 ||
                                estaDeshabilitado(data) ||
                                verificacionSolicitud(data) ||
                                estadoDeshabilitadotelefonica(data)
                              }
                              size="small"
                              sx={{
                                opacity: estaDeshabilitado(data) ? 0.4 : 1,
                                bgcolor: isError ? "#fee2e2" : "#f1f5f9",
                                "&:hover": {
                                  bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                                  transform: "scale(1.1)",
                                },
                                transition: "all 0.2s ease",
                              }}
                            >
                              {getPhoneIconByEstado(
                                data.idEstadoVerificacionTelefonica
                              )}
                            </IconButton>
                            {/* InfoIcon al lado del IconButton */}
                            <span
                              style={{
                                // pointerEvents: estaDeshabilitado(data)
                                //   ? "none"
                                //   : "auto",
                                // opacity: estaDeshabilitado(data) ? 0.5 : 1,
                              }}
                            >
                              <MoreVertIcon
                                onClick={(event) =>
                                  handlePopoverOpen(event, 2, data)
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          </span>

                        </div>
                      </TableCell>

                      {/* Domicilio */}
                      <TableCell align="center">
                        <div >
                          <span>
                            <div className="relative inline-block">
                              <IconButton
                                onClick={() =>
                                  handleOpenModalVerificacion(data, "domicilio")
                                }
                                disabled={
                                  verificacionSolicitud(data) ||
                                  data.Domicilio === false //|| !docAprobados[data.id]
                                }
                                size="small"
                                sx={{
                                  opacity:
                                    data.Domicilio === false
                                      ? 0
                                      : 1,
                                  bgcolor: isError ? "#fee2e2" : "#f1f5f9",
                                  "&:hover": {
                                    bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                                    transform: "scale(1.1)",
                                  },
                                  transition: "all 0.2s ease",
                                }}
                              >
                                {getIconDomicilio(
                                  data.idEstadoVerificacionDomicilio
                                )}
                              </IconButton>
                              {[1, 2, 6].includes(data.Estado) && data.idEstadoVerificacionDomicilio === 0 && permisoEditarVerificacionTerreno() &&
                                (
                                  data.Domicilio === false ||
                                  (data.Domicilio === true && permisoReasignarDomicilio())
                                )

                                && (
                                  <EditIcon
                                    onClick={() => handleOpenDialogDomicilioLaboral(data, "domicilio")}
                                    className="absolute -top-5 -right-3 text-blue-600 cursor-pointer hover:text-blue-800 bg-white rounded-full shadow-sm p-0.5"
                                    fontSize="small"
                                  />
                                )}
                            </div>
                            {/* InfoIcon al lado del IconButton */}

                            <span
                              style={{
                                // pointerEvents: estaDeshabilitado(data)
                                //   ? "none"
                                //   : "auto",
                                // opacity: estaDeshabilitado(data) ? 0.5 : 1,
                              }}
                            >
                              <MoreVertIcon
                                onClick={(event) =>
                                  handlePopoverOpen(event, 4, data)
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          </span>

                        </div>
                      </TableCell>

                      {/* Laborales */}
                      <TableCell align="center">
                        <div>
                          <span>
                            <div className="relative inline-block">
                              <IconButton
                                onClick={() =>
                                  handleOpenModalVerificacion(data, "trabajo")
                                }
                                disabled={
                                  verificacionSolicitud(data) ||
                                  data.Laboral === false

                                }
                                size="small"
                                sx={{
                                  opacity:
                                    data.Laboral === false
                                      ? 0
                                      : 1,
                                  bgcolor: isError ? "#fee2e2" : "#f1f5f9",
                                  "&:hover": {
                                    bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                                    transform: "scale(1.1)",
                                  },
                                  transition: "all 0.2s ease",
                                }}
                              >
                                {getIconLaboral(data.idEstadoVerificacionTerrena)}
                              </IconButton>
                              {[1, 2, 6].includes(data.Estado) && data.idEstadoVerificacionTerrena === 0 && permisoEditarVerificacionTerreno()
                                && (data.Laboral === false || (data.Laboral === true && permisoReasignarLaboral()))
                                && (
                                  <EditIcon
                                    onClick={() => handleOpenDialogDomicilioLaboral(data, "trabajo")}
                                    className="absolute -top-5 -right-3 text-blue-600 cursor-pointer hover:text-blue-800 bg-white rounded-full shadow-sm p-0.5"
                                    fontSize="small"
                                  />
                                )}
                            </div>

                            {/* InfoIcon al lado del IconButton */}
                            <span
                              style={{
                                // pointerEvents: estaDeshabilitado(data)
                                //   ? "none"
                                //   : "auto",
                                // opacity: estaDeshabilitado(data) ? 0.5 : 1,
                              }}
                            >
                              <MoreVertIcon
                                onClick={(event) =>
                                  handlePopoverOpen(event, 5, data)
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </span>
                          </span>


                        </div>
                      </TableCell>

                      {/* Analista */}

                      <TableCell align="center">
                        <Box
                          sx={{
                            position: "relative",
                            display: "inline-block",
                            maxWidth: "100%",
                            px: 1,
                            ...(tienePermisoEditarAnalista() && (data.idEstadoVerificacionSolicitud == 10 || data.idEstadoVerificacionSolicitud == 12) && {
                              "&:hover .analistaNombre": {
                                opacity: 0,
                                visibility: "hidden",
                              },
                              "&:hover .editIcon": {
                                opacity: 1,
                                visibility: "visible",
                              },
                            }),
                          }}
                        >
                          {/* Nombre del analista */}
                          <Box
                            className="analistaNombre"
                            sx={{
                              transition: "opacity 0.2s ease",
                              fontWeight: 500,
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {analistas.find((a) => a.idUsuario === data.idAnalista)?.Nombre || "No disponible"}
                          </Box>

                          {/* Ícono de editar solo si tiene permiso */}
                          {tienePermisoEditarAnalista() && (
                            <Box
                              className="editIcon"
                              onClick={() => handleEditarAnalista(data)}
                              sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                textAlign: "center",
                                opacity: 0,
                                visibility: "hidden",
                                color: "#6b7280",
                                cursor: "pointer",
                                transition: "opacity 0.2s ease",
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </Box>
                          )}
                          <span
                            style={{
                              // pointerEvents: estaDeshabilitado(data)
                              //   ? "none"
                              //   : "auto",
                              // opacity: estaDeshabilitado(data) ? 0.5 : 1,
                            }}
                          >
                            <MoreVertIcon
                              onClick={(event) =>
                                handlePopoverOpen(event, 8, data)
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </span>
                        </Box>
                      </TableCell>

                      {/* OPerador */}
                      <TableCell align="center">
                        <Box
                          sx={{
                            position: "relative",
                            display: "inline-block",
                            maxWidth: "100%",
                            px: 1,
                            ...(permisoEditarOperador() && (data.idEstadoVerificacionSolicitud == 10 || data.idEstadoVerificacionSolicitud == 12) && {
                              "&:hover .operadorNombre": {
                                opacity: 0,
                                visibility: "hidden",
                              },
                              "&:hover .editIcon": {
                                opacity: 1,
                                visibility: "visible",
                              },
                            }),
                          }}
                        >
                          <Box
                            className="operadorNombre"
                            sx={{
                              transition: "opacity 0.2s ease",
                              fontWeight: 500,
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {operadores.find((o) => o.idUsuario === data.Operador)?.Nombre || "Vacio"}
                          </Box>

                          {permisoEditarOperador() && (
                            <Box
                              className="editIcon"
                              onClick={() => handleEditarOperador(data)}
                              sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                textAlign: "center",
                                opacity: 0,
                                visibility: "hidden",
                                color: "#6b7280",
                                cursor: "pointer",
                                transition: "opacity 0.2s ease",
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </Box>
                          )}
                          <span
                            style={{
                              // pointerEvents: estaDeshabilitado(data)
                              //   ? "none"
                              //   : "auto",
                              // opacity: estaDeshabilitado(data) ? 0.5 : 1,
                            }}
                          >
                            <MoreVertIcon
                              onClick={(event) =>
                                handlePopoverOpen(event, 9, data)
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </span>
                        </Box>
                      </TableCell>

                      {/* Informes Operador */}
                      {(
                        // Ambos activos: ambos estados deben ser 2


                        // Solo Domicilio activo
                        (
                          data.Estado !== 5 && data.Estado !== 4 &&
                          data?.Domicilio == 1 &&
                          data?.idEstadoVerificacionDomicilio == 2)


                      ) && (
                          <TableCell align="center">
                            <button
                              onClick={() => {
                                setIsOpenPdf(true);
                                setDataInforme(data);
                              }}
                              className="bg-blue-100 text-blue-700 hover:bg-blue-200 hover:text-blue-900 transition-all duration-200 rounded-full p-2"
                            >
                              <TwoWheelerIcon className="text-blue-700" />
                            </button>
                          </TableCell>
                        )}

                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

      </div>

      {/* Cuadro de diálogo para ver detalles */}
      <VerDetallesModal
        open={view}
        onClose={handleCloseDialog}
        selectedRow={selectedRow}
        fechaTiempos={fechaTiempos}
        previewUrl={previewUrl}
        fileToUpload={fileToUpload}
        inputFileRef={inputFileRef}
        openCameraModal={openCameraModal}
        setOpenCameraModal={setOpenCameraModal}
        setImagenCapturada={setImagenCapturada}
        setPreviewUrl={setPreviewUrl}
        setFileToUpload={setFileToUpload}
        ExistPrefactura={ExistPrefactura}
        showModalRechazo={showModalRechazo}
        setShowModalRechazo={setShowModalRechazo}
        editarCodDac={editarCodDac}
        editarCodDac2={editarCodDac2}
        formatDateTime={formatDateTime}
        calcularTiempoTranscurrido={calcularTiempoTranscurrido}
        sumarTodosLosTiempos={sumarTodosLosTiempos}
        handleFileChange={handleFileChange}
        handleUploadClick={handleUploadClick}
        fetchImagenRegistroCivil={fetchImagenRegistroCivil}
        handleVerificarIdentidad={handleVerificarIdentidad}
        setErrorModalData={setErrorModalData}
        setErrorModalOpen={setErrorModalOpen}
        handleOpenEditModal={handleOpenEditModal}
        puedeAprobar={puedeAprobar}
        permitirEquifax={permitirEquifax}
        handleEquifax={handleEquifax}
        handleAbrirVerificacionManual={handleAbrirVerificacionManual}
        handleRechazar={handleRechazar}
        data={data}
        userData={userData}
        fetchEstadoRegcivil={fetchEstadoRegcivil}
      />

      {/* Modal de carga para verificación facial */}
      <VerificacionFacialLoadingModal open={loadingVerificacion} />

      <Dialog open={openDialog3} onClose={() => setOpenDialog3(false)}>
        <DialogTitle>Seleccionar Analista</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <InputLabel id="select-analista-label">Analista</InputLabel>
            <Select
              labelId="select-analista-label"
              value={analistaSeleccionado || ""}
              onChange={(e) => setAnalistaSeleccionado(e.target.value)}
              label="Analista"
            >
              {analistasDisponibles.map((analista) => (
                <MenuItem key={analista.idUsuario} value={analista.idUsuario}>
                  {analista.Nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog3(false)}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={() => {
              setOpenDialog3(false);
              setOpenDialogConfirmar(true); // Mostrar diálogo de confirmación
            }}
            disabled={!analistaSeleccionado}
          >
            Asignar
          </Button>
        </DialogActions>
      </Dialog>

      {/* confirmacion de cambiar analista  */}
      <Dialog open={openDialogConfirmar} onClose={() => setOpenDialogConfirmar(false)}>
        <DialogTitle>Confirmar acción</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Estás seguro de asignar este analista a la solicitud?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialogConfirmar(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={() => {
              handleConfirmarAsignacion();
            }}
            color="primary"
            variant="contained"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {/* confirmacion de cambiar operador  */}
      <Dialog open={openDialogOperador} onClose={() => setOpenDialogOperador(false)}>
        <DialogTitle>Seleccionar Operador</DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <InputLabel id="select-operador-label">Operador</InputLabel>
            <Select
              labelId="select-operador-label"
              value={operadorSeleccionado || ""}
              onChange={(e) => setOperadorSeleccionado(e.target.value)}
              label="Operador"
            >
              {operadores.map((operador) => (
                <MenuItem key={operador.idUsuario} value={operador.idUsuario}>
                  {operador.Nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialogOperador(false)}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={() => {
              setOpenDialogOperador(false);
              setOpenDialogConfirmarOperador(true); // Mostrar diálogo de confirmación de operador
            }}
            disabled={!operadorSeleccionado}
          >
            Asignar
          </Button>
        </DialogActions>
      </Dialog>

      {/* confirmacion de cambiar operador */}
      <Dialog open={openDialogConfirmarOperador} onClose={() => setOpenDialogConfirmarOperador(false)}>
        <DialogTitle>Confirmar acción</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Estás seguro de asignar este operador a la solicitud?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialogConfirmarOperador(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={() => {
              handleConfirmarAsignacionOperador();
              setOpenDialogConfirmarOperador(false);
            }}
            color="primary"
            variant="contained"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      {totalPages > 1 && (
        <div className="mt-6">
          {/* Layout para escritorio - horizontal */}
          <div className="hidden md:flex justify-between items-center">
            {/* Espacio vacío para alineación */}
            <div className="w-1/3" />

            {/* Navegación centrada */}
            <div className="flex justify-center items-center gap-4 w-1/3">
              <button
                onClick={() => changePage(Math.max(currentPage - 1, 1))}
                disabled={currentPage === 1}
                className="px-2 py-1 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition disabled:invisible"
              >
                <SkipPreviousIcon />
              </button>
              <span className="font-semibold text-gray-600">
                Página {currentPage} de {totalPages}
              </span>
              <button
                onClick={() => changePage(Math.min(currentPage + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-2 py-1 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition disabled:invisible"
              >
                <SkipNextIcon />
              </button>
            </div>

            {/* Select en el extremo derecho */}
            <div className="w-1/3 flex justify-end">
              <select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
              >
                {[5, 10, 15, 20].map((value) => (
                  <option key={value} value={value}>
                    {value} por página
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Layout para móvil - vertical */}
          <div className="flex md:hidden flex-col gap-4 items-center">
            {/* Select arriba */}
            <div className="w-full flex justify-center">
              <select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
              >
                {[5, 10, 15, 20].map((value) => (
                  <option key={value} value={value}>
                    {value} por página
                  </option>
                ))}
              </select>
            </div>

            {/* Navegación abajo */}
            <div className="flex justify-center items-center gap-4">
              <button
                onClick={() => changePage(Math.max(currentPage - 1, 1))}
                disabled={currentPage === 1}
                className="px-2 py-1 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition disabled:invisible"
              >
                <SkipPreviousIcon />
              </button>
              <span className="font-semibold text-gray-600">
                Página {currentPage} de {totalPages}
              </span>
              <button
                onClick={() => changePage(Math.min(currentPage + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-2 py-1 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition disabled:invisible"
              >
                <SkipNextIcon />
              </button>
            </div>
          </div>
        </div>
      )}
      <LocationModal
        isOpen={() => handleOpenModal()}
        openLocationModal={openLocationModal}
        locationType={null}
        locationData={null}
        onLocationChange={null}
        userSolicitudData={userSolicitudData}
      />

      <PreDocumentos
        open={openPreDocumentos}
        onClose={() => setOpenPreDocumentos(false)}
        idSolicitud={preDocumentosData?.data?.id}
        infoSoli={preDocumentosData}
        onContinue={async () => {
          setOpenPreDocumentos(false);

          const data = preDocumentosData.data;
          const tipo = preDocumentosData.tipo;
          const idsTerrenas = idsTerrenasMap[data.id];

          if (!idsTerrenas || idsTerrenas.length === 0) {
            setUserSolicitudData(data);
            setTipoVerificacionSeleccionada(tipo);
            setOpenVerificacionModal(true);
            return;
          }

          if (tipo === "domicilio") {
            if (idsTerrenas.idTerrenaGestionDomicilio > 0) {
              setDomicilioData({ ...idsTerrenas, idSolicitud: data.id });
              setDomicilioModalOpen(true);
            } else if (idsTerrenas.idTerrenaGestionDomicilio === 0) {
              await fetchtiemposolicitudesweb(data.id, 4);
              setOpenModalPendiente(true);
            }
            return;
          }

          if (tipo === "trabajo") {
            if (idsTerrenas.idTerrenaGestionTrabajo > 0) {
              setTrabajoData({ ...idsTerrenas, idSolicitud: data.id });
              setTrabajoModalOpen(true);
            } else if (idsTerrenas.idTerrenaGestionTrabajo === 0) {
              await fetchtiemposolicitudesweb(data.id, 5);
              setOpenModalPendiente(true);
            }
            return;
          }
        }}
      />

      <VerificacionTerrenaModal
        isOpen={openVerificacionModal}
        onClose={() => setOpenVerificacionModal(false)}
        userSolicitudData={userSolicitudData}
        userData={userData}
        tipoSeleccionado={tipoVerificacionSeleccionada}
      />

      {/* reasignar verificador */}
      <VerificacionTerrenaModal
        isOpen={openVerificacionModal2}
        onClose={() => setOpenVerificacionModal2(false)}
        userSolicitudData={userSolicitudData2}
        userData={userData}
        tipoSeleccionado={tipoVerificacionSeleccionada2}
        idClienteVerificacion={idsTerrenas.idClienteVerificacion}
        reasignacion={true}
      />

      <DomicilioModal
        openModal={isDomicilioModalOpen}
        closeModal={handleCloseDomicilioModal}
        idsTerrenas={idsTerrenas}
        idSolicitud={domicilioData?.idSolicitud}
        datosCliente={domicilioData?.cliente}
      />

      <TrabajoModal
        openModal={isTrabajoModalOpen}
        closeModal={handleCloseTrabajoModal}
        idsTerrenas={idsTerrenas}
        idSolicitud={trabajoData?.idSolicitud}
        datosCliente={trabajoData?.cliente}
      />

      <ListVerifDomicilioModal
        openModal={listVerifDomiciModal}
        closeModal={handleCloseVerifDomModal}
        datosCliente={domicilioData}
        userData={userData}
        permisos={permisos}
      />

      <ListVerifLaboralModal
        openModal={listVerifLaborModal}
        closeModal={handleCloseVerifLabModal}
        datosCliente={trabajoData}
        userData={userData}
        permisos={permisos}
      />

      <ModalCorreccion
        isOpen={showModalCorrecion}
        onClose={() => setShowModalCorrecion(false)}
        onConfirm={handleCorreccion}
        solicitudData={selectedRow}
        Titulo='Enviar a Corrección'

        mensajePrincipal={`¿Deseas cambiar la verificación ${TipoVerificacion === "domicilio" ? "domiciliaria" : "laboral"
          } de ${selectedRow
            ? (TipoVerificacion === "domicilio"
              ? selectedRow.Domicilio
              : selectedRow.Laboral)
              ? "ACTIVADA"
              : "DESACTIVADA"
            : ""
          } a ${selectedRow
            ? (TipoVerificacion === "domicilio"
              ? selectedRow.Domicilio
              : selectedRow.Laboral)
              ? "DESACTIVADA"
              : "ACTIVADA"
            : ""
          }?`}
      />


      <ObservacionCredito
        isOpen={observacionModalAbierto}
        onClose={() => setObservacionModalAbierto(false)}
        onConfirm={handleConfirmarObservacion}
        solicitudData={selectedRow}
        mensajePrincipal="Agrega un comentario u observación sobre el crédito seleccionado."
      />
      <CambioBodega
        isOpen={open}
        onClose={() => setOpen(false)}
        onConfirm={handleConfirmarBodega}
        solicitudData={selectedRow}
        mensajePrincipal="Selecciona la nueva bodega de destino para esta solicitud."
        Titulo="Cambiar bodega"
        ListaBodega={bodegas}
      />

      {openModalPendiente && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-full max-w-lg rounded-lg shadow-xl p-6 relative">

            {/* Icono y título */}
            <div className="flex items-center mb-5">
              <div className="bg-yellow-100 text-yellow-600 rounded-full p-2 mr-3">

              </div>
              <h2 className="text-lg font-semibold text-gray-800">
                Verificación pendiente
              </h2>
            </div>

            {/* Cuerpo del mensaje */}
            <p className="text-sm text-gray-700 mb-4">
              Esta solicitud está pendiente de verificación por parte del verificador asignado:
              <span className="ml-2 font-medium text-blue-700">
                {clienteEstados.length > 0 ? clienteEstados[0].Telefono : "N/A"}
              </span>
            </p>

            {/* Acción para reasignar (si tiene permiso) */}
            {permisoReasignarVerificador() && (
              <div className="flex justify-end mt-2">
                <button
                  onClick={() => {
                    setOpenVerificacionModal2(true);
                    setOpenModalPendiente(false);
                  }}
                  className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition"
                >
                  Reasignar Verificador
                </button>
              </div>
            )}

            {/* Línea divisoria */}
            <hr className="my-4" />

            {/* Acciones inferiores */}
            <div className="flex justify-end">
              <button
                onClick={() => setOpenModalPendiente(false)}
                className="text-sm text-gray-600 hover:text-gray-800 hover:underline"
              >
                Cerrar
              </button>
            </div>

            {/* Botón cerrar (X) */}
            <button
              onClick={() => setOpenModalPendiente(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
              aria-label="Cerrar"
            >
              ✕
            </button>
          </div>
        </div>
      )}



      {/* Modal para Registro Civil */}
      <Dialog
        open={openRegistroCivil}
        onClose={() => setOpenRegistroCivil(false)}
        maxWidth="md"
        fullWidth
      >
        <RegistroCivil
          cedula={cedula}
          dactilar={dactilar}
          imagenSubida={selectedRow?.imagen}
          estadoSolicitud={selectedRow?.Estado}
          idSolicitud={selectedRow?.id}
          onAceptar={() => {
            // Acción al aceptar
            patchSolicitud(selectedRow?.id, 2);
            fetchInsertarDatos(6, selectedRow?.id, 2)
            setOpenRegistroCivil(false);
          }}
          onRechazar={() => {
            // Acción al rechazar
            patchSolicitud(selectedRow?.id, 4);
            fetchInsertarDatos(6, selectedRow?.id, 4)
            setOpenRegistroCivil(false);
          }}
          resultadoVerificacion={resultadoVerificacion}
          permisos={permisos}
        />
      </Dialog>

      {/* Dialog de confirmación */}
      <ConfirmarAccionModal
        open={openDialog2}
        onClose={() => setOpenDialog2(false)}
        onConfirm={handleConfirm}
        currentAction={currentAction}
        entrada={entrada}
        setEntrada={setEntrada}
        justificacion={justificacion}
        setJustificacion={setJustificacion}
        domicilioChecked={domicilioChecked}
        setDomicilioChecked={setDomicilioChecked}
        laboralChecked={laboralChecked}
        setLaboralChecked={setLaboralChecked}
      />
      <DocumentoDescarga isOpen={isOpenPDf} onClose={() => setIsOpenPdf(false)} data={dataInforme} />
      <MotivoContinuidad isOpen={isOpenMotivo} onClose={() => setIsOpenMotivo(false)} data={dataInforme} userData={userData} />

      {/* Modal codigo dactilar */}
      <Dialog open={openModalCodDag} onClose={() => setOpenModalCodDag(false)}>
        <DialogTitle>Cambiar codigo Dactilar</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Ingresa el nuevo código dactilar:
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            value={codDact}
            onChange={(e) => setCodDact(e.target.value)}
            placeholder="Ingresa el código dactilar"
            autoFocus
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModalCodDag(false)} color="primary">
            Cerrar
          </Button>
          <Button onClick={handleUpdateClick} color="primary" variant="contained">
            Actualizar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de confirmación */}
      <Dialog
        open={openConfirmModalCodDac}
        onClose={() => setOpenConfirmModalCodDac(false)}
        maxWidth="xs"
      >
        <DialogTitle>Confirmar actualización</DialogTitle>
        <DialogContent>
          <Typography>
            ¿Está seguro de actualizar el código dactilar?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmModalCodDac(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleConfirmUpdate} color="primary" variant="contained">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>

      <ExcelModal
        open={openModalExcel}
        onClose={() => setOpenModalExcel(false)}
        bodegas={dataBodega}
      />

      {/* Modal de Error Visual para Registro Civil y Verificación */}
      <Dialog
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
          }
        }}
      >
        <DialogTitle sx={{
          bgcolor: errorModalData.tipo === 'verificacion_exitosa'
            ? '#d4edda'
            : errorModalData.tipo === 'verificacion_fallida'
              ? '#fff3cd'
              : errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado'
                ? '#fff3cd'
                : errorModalData.tipo === 'datos_incompletos'
                  ? '#f8d7da'
                  : '#d1ecf1',
          color: errorModalData.tipo === 'verificacion_exitosa'
            ? '#155724'
            : errorModalData.tipo === 'verificacion_fallida'
              ? '#856404'
              : errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado'
                ? '#856404'
                : errorModalData.tipo === 'datos_incompletos'
                  ? '#721c24'
                  : '#0c5460',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          pb: 2
        }}>
          {errorModalData.tipo === 'verificacion_exitosa' ? (
            <CheckCircleIcon sx={{ fontSize: 40, color: '#28a745' }} />
          ) : errorModalData.tipo === 'verificacion_fallida' ? (
            <ReportProblemIcon sx={{ fontSize: 40, color: '#ffc107' }} />
          ) : errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado' ? (
            <PersonSearchIcon sx={{ fontSize: 40 }} />
          ) : errorModalData.tipo === 'datos_incompletos' ? (
            <ReportProblemIcon sx={{ fontSize: 40 }} />
          ) : (
            <HighlightOffIcon sx={{ fontSize: 40 }} />
          )}
          <Typography variant="h6" component="div" fontWeight="bold">
            {errorModalData.mensaje}
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ mt: 3, mb: 2 }}>
          <Box sx={{
            bgcolor: errorModalData.tipo === 'verificacion_exitosa' ? '#f0f9f4' : '#f8f9fa',
            p: 3,
            borderRadius: '8px',
            border: `1px solid ${errorModalData.tipo === 'verificacion_exitosa' ? '#c3e6cb' : '#dee2e6'}`
          }}>
            <Typography
              variant="body1"
              sx={{
                whiteSpace: 'pre-line',
                color: '#495057',
                lineHeight: 1.8
              }}
            >
              {errorModalData.detalle}
            </Typography>
          </Box>

          {(errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado') && (
            <Box sx={{ mt: 3, p: 2, bgcolor: '#e7f3ff', borderRadius: '8px', border: '1px solid #b3d9ff' }}>
              <Typography variant="body2" sx={{ color: '#004085', fontWeight: 500, mb: 1 }}>
                💡 Sugerencias:
              </Typography>
              <Typography variant="body2" sx={{ color: '#004085', pl: 2 }}>
                • Verifique que la cédula esté correctamente digitada<br />
                • Confirme que el código dactilar sea el correcto<br />
                • Consulte con el cliente si es necesario<br />
                • Si el problema persiste, contacte al área técnica
              </Typography>
            </Box>
          )}

          {errorModalData.tipo === 'verificacion_fallida' && (
            <Box sx={{ mt: 3, p: 2, bgcolor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffc107' }}>
              <Typography variant="body2" sx={{ color: '#856404', fontWeight: 500, mb: 1 }}>
                ⚠️ Acciones requeridas:
              </Typography>
              <Typography variant="body2" sx={{ color: '#856404', pl: 2 }}>
                • Revise manualmente ambas fotografías<br />
                • Contacte al analista asignado a esta solicitud<br />
                • Considere solicitar nuevas fotos al cliente<br />
                • Documente el motivo del rechazo en el sistema
              </Typography>
            </Box>
          )}

          {errorModalData.tipo === 'verificacion_exitosa' && (
            <Box sx={{ mt: 3, p: 2, bgcolor: '#d4edda', borderRadius: '8px', border: '1px solid #c3e6cb' }}>
              <Typography variant="body2" sx={{ color: '#155724', fontWeight: 500, mb: 1 }}>
                ✓ Verificación completada
              </Typography>
              <Typography variant="body2" sx={{ color: '#155724', pl: 2 }}>
                La solicitud ha sido procesada y aprobada automáticamente.<br />
                Puede continuar con el siguiente paso del proceso.
              </Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={() => setErrorModalOpen(false)}
            variant="contained"
            sx={{
              bgcolor: errorModalData.tipo === 'verificacion_exitosa'
                ? '#28a745'
                : errorModalData.tipo === 'verificacion_fallida'
                  ? '#ffc107'
                  : errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado'
                    ? '#ffc107'
                    : errorModalData.tipo === 'datos_incompletos'
                      ? '#dc3545'
                      : '#17a2b8',
              '&:hover': {
                bgcolor: errorModalData.tipo === 'verificacion_exitosa'
                  ? '#218838'
                  : errorModalData.tipo === 'verificacion_fallida'
                    ? '#e0a800'
                    : errorModalData.tipo === 'datos_incorrectos' || errorModalData.tipo === 'ciudadano_no_encontrado'
                      ? '#e0a800'
                      : errorModalData.tipo === 'datos_incompletos'
                        ? '#c82333'
                        : '#138496',
              },
              px: 4,
              py: 1,
              borderRadius: '8px',
              fontWeight: 'bold'
            }}
          >
            Entendido
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Verificación Facial con Tailwind CSS */}
      <VerificacionFacialModal
        open={verificacionModalOpen}
        onClose={() => setVerificacionModalOpen(false)}
        tipo={verificacionModalTipo}
        data={verificacionModalData}
      />

      {/* Modal de Firma Electrónica: debe estar fuera de la tabla para sobreponerse */}
      <ModalFirmaElectronica data={selectedRow} isOpen={modalFirmaOpen} onClose={() => setModalFirmaOpen(false)} />

    </div>
  );
}